(function(){try{if(typeof document<`u`){var e=document.createElement(`style`);e.appendChild(document.createTextNode(`._root_1p912_54{position:relative}._root_1p912_54._disabled_1p912_57 ._toolbar_1p912_57,._root_1p912_54._disabled_1p912_57 ._addButton_1p912_58{opacity:var(--dixa-effect-opacity-500);pointer-events:none}._editorWrapper_1p912_63{box-sizing:border-box;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);background-color:var(--dixa-color-neutral-000);width:100%;display:block}._editorWrapper_1p912_63:hover{border-color:var(--dixa-color-neutral-400)}._editorWrapper_1p912_63:focus-within{border:var(--dixa-size-border-100) solid var(--dixa-color-purple-500);box-shadow:0 0 0 2px var(--dixa-color-purple-300)}._editorWrapper_1p912_63._textarea_1p912_78{padding:var(--dixa-size-spacer-200) 0;resize:vertical;flex-direction:column;min-height:240px;display:flex;overflow:auto}._editorWrapper_1p912_63._textarea_1p912_78 ._editor_1p912_63{flex:auto}._editorWrapper_1p912_63._input_1p912_90{align-items:center;height:40px;min-height:40px;padding:0;display:flex;overflow:hidden auto}._editorWrapper_1p912_63._input_1p912_90 span:not(._token_1p912_99){white-space:pre;display:inline}._editorWrapper_1p912_63._disabled_1p912_57{opacity:var(--dixa-effect-opacity-500)}._editorWrapper_1p912_63._disabled_1p912_57 ._editor_1p912_63{cursor:default}._editor_1p912_63{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);box-sizing:border-box;cursor:text;width:100%;max-width:100%;height:100%;color:var(--dixa-typography-color-primary);font-family:var(--dixa-typography-family-default);font-weight:var(--dixa-typography-weight-normal);font-size:var(--dixa-typography-size-300);letter-spacing:var(--dixa-typography-letter-spacing-300);line-height:28px;display:block;overflow-y:auto}._editor_1p912_63 p{margin:0}._editor_1p912_63 span[data-slate-placeholder]{width:auto!important}._toolbar_1p912_57{align-items:center;gap:var(--dixa-size-spacer-100);padding-left:var(--dixa-size-spacer-200);padding-right:var(--dixa-size-spacer-200);border-left:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);display:flex}._toolbarTop_1p912_143{padding-top:var(--dixa-size-spacer-200);padding-bottom:calc(var(--dixa-size-spacer-200) + 2px);margin:var(--dixa-size-spacer-100) 0 -2px;border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0 0}._toolbarBottom_1p912_151{padding-top:calc(var(--dixa-size-spacer-200) + 2px);padding-bottom:var(--dixa-size-spacer-200);margin:-2px 0 var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:0 0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100)}._toolbarButton_1p912_159{cursor:pointer;padding:var(--dixa-size-spacer-100);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-typography-color-secondary);background:0 0;border:none;justify-content:center;align-items:center;display:flex}._toolbarButton_1p912_159:hover{background-color:var(--dixa-color-neutral-100);color:var(--dixa-typography-color-primary)}._toolbarButtonActive_1p912_175{background-color:var(--dixa-color-neutral-200);color:var(--dixa-typography-color-primary)}._toolbarInsertVariable_1p912_180{padding-left:var(--dixa-size-spacer-200);padding-right:var(--dixa-size-spacer-200);color:var(--dixa-color-blue-500);white-space:nowrap;font-size:12px;font-weight:600;line-height:16px}._toolbarInsertVariable_1p912_180:hover{color:var(--dixa-color-blue-700)}._list_1p912_193{padding-left:var(--dixa-size-spacer-500);margin:0}._list_1p912_193 li{margin:0}._heading_1p912_201{font-weight:var(--dixa-typography-weight-semibold);margin:0;line-height:1.3}h1._heading_1p912_201{font-size:24px}h2._heading_1p912_201{font-size:20px}h3._heading_1p912_201{font-size:16px}._listItemContent_1p912_219{margin:0}._emojiRow_1p912_223{align-items:center;gap:var(--dixa-size-spacer-200);display:flex}._emojiGlyph_1p912_229{font-size:18px;line-height:1}._emojiPickerPortal_1p912_234{background-color:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);box-shadow:0 2px 8px color-mix(in srgb, var(--dixa-color-neutral-900) 20%, transparent);z-index:10600}._token_1p912_99{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);margin:0 var(--dixa-size-spacer-100);vertical-align:baseline;border-radius:var(--dixa-size-border-radius-100);background-color:var(--dixa-color-purple-100);color:var(--dixa-color-purple-700);-webkit-user-select:none;user-select:none;align-items:center;padding:2px 5px 2px 3px;font-size:12px;font-weight:600;line-height:16px;display:inline-flex}._token_1p912_99:hover{background-color:var(--dixa-color-purple-200)}._token_1p912_99._selected_1p912_259{box-shadow:0 0 0 var(--dixa-size-border-100) var(--dixa-color-purple-500)}._unresolvedToken_1p912_263{background-color:var(--dixa-color-orange-100);color:var(--dixa-color-orange-900);border:1px solid var(--dixa-color-orange-300);cursor:pointer}._unresolvedToken_1p912_263:before{content:"Placeholder";background-color:var(--dixa-color-orange-200);color:var(--dixa-color-orange-700);border-radius:2px;margin-right:8px;padding:0 4px;font-size:10px;line-height:16px}._unresolvedToken_1p912_263:hover{background-color:var(--dixa-color-orange-200)}._tokenEditIcon_1p912_283{margin-left:var(--dixa-size-spacer-100);flex-shrink:0}._buttonPortal_1p912_288{padding:var(--dixa-size-spacer-100);background-color:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);box-shadow:0 2px 8px color-mix(in srgb, var(--dixa-color-neutral-900) 20%, transparent);z-index:10600;min-width:300px;max-height:350px;overflow-y:auto}._portal_1p912_299{padding:var(--dixa-size-spacer-100);background-color:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);box-shadow:0 2px 8px color-mix(in srgb, var(--dixa-color-neutral-900) 20%, transparent);z-index:10600;min-width:250px;max-height:300px;position:fixed;overflow-y:auto}._suggestion_1p912_311{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300);border-radius:var(--dixa-size-border-radius-100);cursor:pointer}._suggestion_1p912_311:hover,._suggestion_1p912_311._highlighted_1p912_319{background-color:var(--dixa-color-neutral-100)}._suggestion_1p912_311._disabled_1p912_57{cursor:not-allowed;opacity:.5}._suggestion_1p912_311._disabled_1p912_57:hover{background-color:#0000}._placeholder_1p912_330{pointer-events:none;color:var(--dixa-color-neutral-500);-webkit-user-select:none;user-select:none;position:absolute}._addButton_1p912_58{color:var(--dixa-color-blue-500);leading-trim:NONE;letter-spacing:-.08px;background:0 0;border:none;font-size:12px;font-weight:600;line-height:16px;position:absolute;top:0;right:0}._divider_1p912_351{margin:var(--dixa-size-spacer-200);font-size:var(--dixa-typography-size-200);font-weight:var(--dixa-typography-weight-normal);line-height:var(--dixa-typography-line-height-200);letter-spacing:var(--dixa-typography-letter-spacing-400);color:var(--dixa-typography-color-primary)}._popoverTopButton_1p912_360{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300);border-radius:var(--dixa-size-border-radius-100);cursor:pointer;font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300)}._popoverTopButton_1p912_360:hover{background-color:var(--dixa-color-neutral-100)}._suggestionWithActions_1p912_371{justify-content:space-between;align-items:center;display:flex}._suggestionActions_1p912_377{gap:var(--dixa-size-spacer-100);flex-shrink:0;display:none}._suggestionWithActions_1p912_371:hover ._suggestionActions_1p912_377{display:flex}._suggestionActionButton_1p912_386{cursor:pointer;color:var(--dixa-typography-color-secondary);border-radius:var(--dixa-size-border-radius-100);background:0 0;border:none;align-items:center;padding:2px;display:flex}._suggestionActionButton_1p912_386:hover{background-color:var(--dixa-color-neutral-200);color:var(--dixa-typography-color-primary)}/*$vite$:1*/`)),document.head.appendChild(e)}}catch(e){console.error(`vite-plugin-css-injected-by-js`,e)}})();
import { Divider as e, EMOJIS as t, EmojiPicker as n, FieldWrapper as r, Icon as i, Portal as a, Text as o, TextWithHighlight as s, Tooltip as c, formatShortcut as l, isKeyCombination as u } from "@dixa/lib-shared-habla";
import * as d from "react";
import { Fragment as f, useCallback as p, useEffect as m, useLayoutEffect as h, useMemo as g, useRef as _, useState as v } from "react";
import { Fragment as y, jsx as b, jsxs as x } from "react/jsx-runtime";
import * as S from "react-dom";
import C from "classnames";
import { useHookFormFieldWrapper as w } from "lib-shared-hook-form";
import T from "lodash/groupBy";
import E from "lodash/sortBy";
import { Editor as D, Element as O, Node as k, Path as A, Point as j, Range as M, Text as ee, Transforms as N, createEditor as te } from "slate";
import { withHistory as ne } from "slate-history";
import { Editable as re, ReactEditor as ie, Slate as ae, useSlate as oe, withReact as se } from "slate-react";
// \0rolldown/runtime.js
var ce = (e, t, n) => () => {
	if (n) throw n[0];
	try {
		return e && (t = e(e = 0)), t;
	} catch (e) {
		throw n = [e], e;
	}
}, le = Object.defineProperty, ue = (e, t) => le(e, "name", {
	value: t,
	configurable: !0
}), de = !!(typeof window < "u" && window.document && window.document.createElement);
function P(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
	return /* @__PURE__ */ ue(function(r) {
		if (e?.(r), n === !1 || !r || !r.defaultPrevented) return t?.(r);
	}, "handleEvent");
}
ue(P, "composeEventHandlers");
function fe(e) {
	if (!de) throw Error("Cannot access window outside of the DOM");
	return e?.ownerDocument?.defaultView ?? window;
}
ue(fe, "getOwnerWindow");
function F(e) {
	if (!de) throw Error("Cannot access document outside of the DOM");
	return e?.ownerDocument ?? document;
}
ue(F, "getOwnerDocument");
function I(e, t = !1) {
	let { activeElement: n } = F(e);
	if (!n?.nodeName) return null;
	if (pe(n) && n.contentDocument) return I(n.contentDocument.body, t);
	if (t) {
		let e = n.getAttribute("aria-activedescendant");
		if (e) {
			let t = F(n).getElementById(e);
			if (t) return t;
		}
	}
	return n;
}
ue(I, "getActiveElement");
function pe(e) {
	return e.tagName === "IFRAME";
}
ue(pe, "isFrame");
// ../../../node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var L = Object.defineProperty, me = (e, t) => L(e, "name", {
	value: t,
	configurable: !0
});
function he(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
me(he, "setRef");
function ge(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = he(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : he(e[t], null);
			}
		};
	};
}
me(ge, "composeRefs");
function _e(...e) {
	return d.useCallback(ge(...e), e);
}
me(_e, "useComposedRefs");
// ../../../node_modules/@radix-ui/react-context/dist/index.mjs
var ve = Object.defineProperty, R = (e, t) => ve(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function ye(e, t) {
	let n = d.createContext(t);
	n.displayName = e + "Context";
	let r = /* @__PURE__ */ R((e) => {
		let { children: t, ...r } = e, i = d.useMemo(() => r, Object.values(r));
		return /* @__PURE__ */ b(n.Provider, {
			value: i,
			children: t
		});
	}, "Provider");
	r.displayName = e + "Provider";
	function i(r, i = {}) {
		let { optional: a = !1 } = i, o = d.useContext(n);
		if (o) return o;
		if (t !== void 0) return t;
		if (!a) throw Error(`\`${r}\` must be used within \`${e}\``);
	}
	return R(i, "useContext"), [r, i];
}
R(ye, "createContext");
// @__NO_SIDE_EFFECTS__
function be(e, t = []) {
	let n = [];
	function r(t, r) {
		let i = d.createContext(r);
		i.displayName = t + "Context";
		let a = n.length;
		n = [...n, r];
		let o = /* @__PURE__ */ R((t) => {
			let { scope: n, children: r, ...o } = t, s = n?.[e]?.[a] || i, c = d.useMemo(() => o, Object.values(o));
			return /* @__PURE__ */ b(s.Provider, {
				value: c,
				children: r
			});
		}, "Provider");
		o.displayName = t + "Provider";
		function s(n, o, s = {}) {
			let { optional: c = !1 } = s, l = o?.[e]?.[a] || i, u = d.useContext(l);
			if (u) return u;
			if (r !== void 0) return r;
			if (!c) throw Error(`\`${n}\` must be used within \`${t}\``);
		}
		return R(s, "useContext"), [o, s];
	}
	R(r, "createContext");
	let i = /* @__PURE__ */ R(() => {
		let t = n.map((e) => d.createContext(e));
		return /* @__PURE__ */ R(function(n) {
			let r = n?.[e] || t;
			return d.useMemo(() => ({ [`__scope${e}`]: {
				...n,
				[e]: r
			} }), [n, r]);
		}, "useScope");
	}, "createScope");
	return i.scopeName = e, [r, xe(i, ...t)];
}
R(be, "createContextScope");
function xe(...e) {
	let t = e[0];
	if (e.length === 1) return t;
	let n = /* @__PURE__ */ R(() => {
		let n = e.map((e) => ({
			useScope: e(),
			scopeName: e.scopeName
		}));
		return /* @__PURE__ */ R(function(e) {
			let r = n.reduce((t, { useScope: n, scopeName: r }) => {
				let i = n(e)[`__scope${r}`];
				return {
					...t,
					...i
				};
			}, {});
			return d.useMemo(() => ({ [`__scope${t.scopeName}`]: r }), [r]);
		}, "useComposedScopes");
	}, "createScope");
	return n.scopeName = t.scopeName, n;
}
R(xe, "composeContextScopes");
// ../../../node_modules/@radix-ui/react-slot/dist/index.mjs
var Se = Object.defineProperty, z = (e, t) => Se(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function Ce(e) {
	let t = d.forwardRef((t, n) => {
		let { children: r, ...i } = t, a = null, o = !1, s = [];
		je(r) && typeof B == "function" && (r = B(r._payload)), d.Children.forEach(r, (e) => {
			if (ke(e)) {
				o = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				je(n) && typeof B == "function" && (n = B(n._payload)), a = Ee(t, n), s.push(a?.props?.children);
			} else s.push(e);
		}), a ? a = d.cloneElement(a, void 0, s) : !o && d.Children.count(r) === 1 && d.isValidElement(r) && (a = r);
		let c = a ? Oe(a) : void 0, l = _e(n, c);
		if (!a) {
			if (r || r === 0) throw Error(o ? Pe(e) : Ne(e));
			return r;
		}
		let u = De(i, a.props ?? {});
		return a.type !== d.Fragment && (u.ref = n ? l : c), d.cloneElement(a, u);
	});
	return t.displayName = `${e}.Slot`, t;
}
z(Ce, "createSlot");
var we = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function Te(e) {
	let t = /* @__PURE__ */ z((e) => "child" in e ? e.children(e.child) : e.children, "Slottable");
	return t.displayName = `${e}.Slottable`, t.__radixId = we, t;
}
z(Te, "createSlottable");
var Ee = /* @__PURE__ */ z((e, t) => {
	if ("child" in e.props) {
		let t = e.props.child;
		return d.isValidElement(t) ? d.cloneElement(t, void 0, e.props.children(t.props.children)) : null;
	}
	return d.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function De(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
z(De, "mergeProps");
function Oe(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
z(Oe, "getElementRef");
function ke(e) {
	return d.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === we;
}
z(ke, "isSlottable");
var Ae = Symbol.for("react.lazy");
function je(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === Ae && "_payload" in e && Me(e._payload);
}
z(je, "isLazyComponent");
function Me(e) {
	return typeof e == "object" && !!e && "then" in e;
}
z(Me, "isPromiseLike");
var Ne = /* @__PURE__ */ z((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), Pe = /* @__PURE__ */ z((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), B = d.use, Fe = Object.defineProperty, Ie = (e, t) => Fe(e, "name", {
	value: t,
	configurable: !0
}), V = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"select",
	"span",
	"svg",
	"ul"
].reduce((e, t) => {
	let n = /* @__PURE__ */ Ce(`Primitive.${t}`), r = d.forwardRef((e, r) => {
		let { asChild: i, ...a } = e, o = i ? n : t;
		return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ b(o, {
			...a,
			ref: r
		});
	});
	return r.displayName = `Primitive.${t}`, {
		...e,
		[t]: r
	};
}, {});
function Le(e, t) {
	e && S.flushSync(() => e.dispatchEvent(t));
}
Ie(Le, "dispatchDiscreteCustomEvent");
// ../../../node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
var Re = Object.defineProperty, ze = (e, t) => Re(e, "name", {
	value: t,
	configurable: !0
});
function H(e) {
	let t = d.useRef(e);
	return d.useEffect(() => {
		t.current = e;
	}), d.useMemo(() => ((...e) => t.current?.(...e)), []);
}
ze(H, "useCallbackRef");
// ../../../node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
var Be = Object.defineProperty, U = (e, t) => Be(e, "name", {
	value: t,
	configurable: !0
}), Ve = "dismissableLayer.update", He = "dismissableLayer.pointerDownOutside", Ue = "dismissableLayer.focusOutside", We, Ge = d.createContext({
	layers: /* @__PURE__ */ new Set(),
	layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
	branches: /* @__PURE__ */ new Set(),
	dismissableSurfaces: /* @__PURE__ */ new Set()
}), Ke = /* @__PURE__ */ d.forwardRef(/* @__PURE__ */ U(function(e, t) {
	let { disableOutsidePointerEvents: n = !1, deferPointerDownOutside: r = !1, onEscapeKeyDown: i, onPointerDownOutside: a, onFocusOutside: o, onInteractOutside: s, onDismiss: c, ...l } = e, u = d.useContext(Ge), [f, p] = d.useState(null), m = f?.ownerDocument ?? globalThis?.document, [, h] = d.useState({}), g = _e(t, p), _ = Array.from(u.layers), [v] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), y = v ? _.indexOf(v) : -1, x = f ? _.indexOf(f) : -1, S = u.layersWithOutsidePointerEventsDisabled.size > 0, C = x >= y, w = d.useRef(!1), T = Ye((e) => {
		a?.(e), s?.(e), e.defaultPrevented || c?.();
	}, {
		ownerDocument: m,
		deferPointerDownOutside: r,
		isDeferredPointerDownOutsideRef: w,
		dismissableSurfaces: u.dismissableSurfaces,
		shouldHandlePointerDownOutside: d.useCallback((e) => {
			if (!(e instanceof Node)) return !1;
			let t = [...u.branches].some((t) => t.contains(e));
			return C && !t;
		}, [u.branches, C])
	}), E = Xe((e) => {
		if (r && w.current) return;
		let t = e.target;
		[...u.branches].some((e) => e.contains(t)) || (o?.(e), s?.(e), e.defaultPrevented || c?.());
	}, m), D = f ? x === _.length - 1 : !1, O = H((e) => {
		e.key === "Escape" && (i?.(e), !e.defaultPrevented && c && (e.preventDefault(), c()));
	});
	return d.useEffect(() => {
		if (D) return m.addEventListener("keydown", O, { capture: !0 }), () => m.removeEventListener("keydown", O, { capture: !0 });
	}, [
		m,
		D,
		O
	]), d.useEffect(() => {
		if (f) return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (We = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(f)), u.layers.add(f), Ze(), () => {
			n && (u.layersWithOutsidePointerEventsDisabled.delete(f), u.layersWithOutsidePointerEventsDisabled.size === 0 && (m.body.style.pointerEvents = We));
		};
	}, [
		f,
		m,
		n,
		u
	]), d.useEffect(() => () => {
		f && (u.layers.delete(f), u.layersWithOutsidePointerEventsDisabled.delete(f), Ze());
	}, [f, u]), d.useEffect(() => {
		let e = /* @__PURE__ */ U(() => h({}), "handleUpdate");
		return document.addEventListener(Ve, e), () => document.removeEventListener(Ve, e);
	}, []), /* @__PURE__ */ b(V.div, {
		...l,
		ref: g,
		style: {
			pointerEvents: S ? C ? "auto" : "none" : void 0,
			...e.style
		},
		onFocusCapture: P(e.onFocusCapture, E.onFocusCapture),
		onBlurCapture: P(e.onBlurCapture, E.onBlurCapture),
		onPointerDownCapture: P(e.onPointerDownCapture, T.onPointerDownCapture)
	});
}, "DismissableLayer"));
function qe() {
	let e = d.useContext(Ge), [t, n] = d.useState(null);
	return d.useEffect(() => {
		if (t) return e.dismissableSurfaces.add(t), () => {
			e.dismissableSurfaces.delete(t);
		};
	}, [t, e.dismissableSurfaces]), n;
}
U(qe, "useDismissableLayerSurface");
var Je = /* @__PURE__ */ U(() => !0, "IS_TRUE");
function Ye(e, t) {
	let { ownerDocument: n = globalThis?.document, deferPointerDownOutside: r = !1, isDeferredPointerDownOutsideRef: i, dismissableSurfaces: a, shouldHandlePointerDownOutside: o = Je } = t, s = H(e), c = d.useRef(!1), l = d.useRef(!1), u = d.useRef(/* @__PURE__ */ new Map()), f = d.useRef(() => {});
	return d.useEffect(() => {
		function e() {
			l.current = !1, i.current = !1, u.current.clear();
		}
		U(e, "resetOutsideInteraction");
		function t() {
			return Array.from(u.current.values()).some(Boolean);
		}
		U(t, "isOutsideInteractionIntercepted");
		function d(e) {
			if (!l.current) return;
			let t = e.target;
			t instanceof Node && [...a].some((e) => e.contains(t)) || u.current.set(e.type, !0), e.type === "click" && window.setTimeout(() => {
				l.current && f.current();
			}, 0);
		}
		U(d, "handleInteractionCapture");
		function p(e) {
			l.current && u.current.set(e.type, !1);
		}
		U(p, "handleInteractionBubble");
		let m = /* @__PURE__ */ U((a) => {
			if (a.target && !c.current) {
				let d = function() {
					n.removeEventListener("click", f.current);
					let r = t();
					e(), r || Qe(He, s, p, { discrete: !0 });
				};
				if (U(d, "handleAndDispatchPointerDownOutsideEvent"), !o(a.target)) {
					n.removeEventListener("click", f.current), e(), c.current = !1;
					return;
				}
				let p = { originalEvent: a };
				l.current = !0, i.current = r && a.button === 0, u.current.clear(), !r || a.button !== 0 ? d() : (n.removeEventListener("click", f.current), f.current = d, n.addEventListener("click", f.current, { once: !0 }));
			} else n.removeEventListener("click", f.current), e();
			c.current = !1;
		}, "handlePointerDown"), h = [
			"pointerup",
			"mousedown",
			"mouseup",
			"touchstart",
			"touchend",
			"click"
		];
		for (let e of h) n.addEventListener(e, d, !0), n.addEventListener(e, p);
		let g = window.setTimeout(() => {
			n.addEventListener("pointerdown", m);
		}, 0);
		return () => {
			window.clearTimeout(g), n.removeEventListener("pointerdown", m), n.removeEventListener("click", f.current);
			for (let e of h) n.removeEventListener(e, d, !0), n.removeEventListener(e, p);
		};
	}, [
		n,
		s,
		r,
		i,
		a,
		o
	]), { onPointerDownCapture: /* @__PURE__ */ U(() => c.current = !0, "onPointerDownCapture") };
}
U(Ye, "usePointerDownOutside");
function Xe(e, t = globalThis?.document) {
	let n = H(e), r = d.useRef(!1);
	return d.useEffect(() => {
		let e = /* @__PURE__ */ U((e) => {
			e.target && !r.current && Qe(Ue, n, { originalEvent: e }, { discrete: !1 });
		}, "handleFocus");
		return t.addEventListener("focusin", e), () => t.removeEventListener("focusin", e);
	}, [t, n]), {
		onFocusCapture: /* @__PURE__ */ U(() => r.current = !0, "onFocusCapture"),
		onBlurCapture: /* @__PURE__ */ U(() => r.current = !1, "onBlurCapture")
	};
}
U(Xe, "useFocusOutside");
function Ze() {
	let e = new CustomEvent(Ve);
	document.dispatchEvent(e);
}
U(Ze, "dispatchUpdate");
function Qe(e, t, n, { discrete: r }) {
	let i = n.originalEvent.target, a = new CustomEvent(e, {
		bubbles: !1,
		cancelable: !0,
		detail: n
	});
	t && i.addEventListener(e, t, { once: !0 }), r ? Le(i, a) : i.dispatchEvent(a);
}
U(Qe, "handleAndDispatchCustomEvent");
// ../../../node_modules/@radix-ui/react-focus-guards/dist/index.mjs
var $e = Object.defineProperty, et = (e, t) => $e(e, "name", {
	value: t,
	configurable: !0
}), tt = 0, nt = null;
function rt(e) {
	return it(), e.children;
}
et(rt, "FocusGuards");
function it() {
	d.useEffect(() => {
		nt ||= {
			start: at(),
			end: at()
		};
		let { start: e, end: t } = nt;
		return document.body.firstElementChild !== e && document.body.insertAdjacentElement("afterbegin", e), document.body.lastElementChild !== t && document.body.insertAdjacentElement("beforeend", t), tt++, () => {
			tt === 1 && (nt?.start.remove(), nt?.end.remove(), nt = null), tt = Math.max(0, tt - 1);
		};
	}, []);
}
et(it, "useFocusGuards");
function at() {
	let e = document.createElement("span");
	return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
et(at, "createFocusGuard");
// ../../../node_modules/@radix-ui/react-focus-scope/dist/index.mjs
var ot = Object.defineProperty, W = (e, t) => ot(e, "name", {
	value: t,
	configurable: !0
}), st = "focusScope.autoFocusOnMount", ct = "focusScope.autoFocusOnUnmount", lt = {
	bubbles: !1,
	cancelable: !0
}, ut = /* @__PURE__ */ d.forwardRef(/* @__PURE__ */ W(function(e, t) {
	let { loop: n = !1, trapped: r = !1, onMountAutoFocus: i, onUnmountAutoFocus: a, ...o } = e, [s, c] = d.useState(null), l = H(i), u = H(a), f = d.useRef(null), p = _e(t, c), m = d.useRef({
		paused: !1,
		pause() {
			this.paused = !0;
		},
		resume() {
			this.paused = !1;
		}
	}).current;
	d.useEffect(() => {
		if (r) {
			let e = function(e) {
				if (m.paused || !s) return;
				let t = e.target;
				s.contains(t) ? f.current = t : _t(f.current, { select: !0 });
			}, t = function(e) {
				if (m.paused || !s) return;
				let t = e.relatedTarget;
				t !== null && (s.contains(t) || _t(f.current, { select: !0 }));
			}, n = function(e) {
				if (document.activeElement === document.body) for (let t of e) t.removedNodes.length > 0 && _t(s);
			};
			W(e, "handleFocusIn"), W(t, "handleFocusOut"), W(n, "handleMutations"), document.addEventListener("focusin", e), document.addEventListener("focusout", t);
			let r = new MutationObserver(n);
			return s && r.observe(s, {
				childList: !0,
				subtree: !0
			}), () => {
				document.removeEventListener("focusin", e), document.removeEventListener("focusout", t), r.disconnect();
			};
		}
	}, [
		r,
		s,
		m.paused
	]), d.useEffect(() => {
		if (s) {
			vt.add(m);
			let e = document.activeElement;
			if (!s.contains(e)) {
				let t = new CustomEvent(st, lt);
				s.addEventListener(st, l), s.dispatchEvent(t), t.defaultPrevented || (dt(xt(pt(s)), { select: !0 }), document.activeElement === e && _t(s));
			}
			return () => {
				s.removeEventListener(st, l), setTimeout(() => {
					let t = new CustomEvent(ct, lt);
					s.addEventListener(ct, u), s.dispatchEvent(t), t.defaultPrevented || _t(e ?? document.body, { select: !0 }), s.removeEventListener(ct, u), vt.remove(m);
				}, 0);
			};
		}
	}, [
		s,
		l,
		u,
		m
	]);
	let h = d.useCallback((e) => {
		if (!n && !r || m.paused) return;
		let t = e.key === "Tab" && !e.altKey && !e.ctrlKey && !e.metaKey, i = document.activeElement;
		if (t && i) {
			let t = e.currentTarget, [r, a] = ft(t);
			r && a ? !e.shiftKey && i === a ? (e.preventDefault(), n && _t(r, { select: !0 })) : e.shiftKey && i === r && (e.preventDefault(), n && _t(a, { select: !0 })) : i === t && e.preventDefault();
		}
	}, [
		n,
		r,
		m.paused
	]);
	return /* @__PURE__ */ b(V.div, {
		tabIndex: -1,
		...o,
		ref: p,
		onKeyDown: h
	});
}, "FocusScope"));
function dt(e, { select: t = !1 } = {}) {
	let n = document.activeElement;
	for (let r of e) if (_t(r, { select: t }), document.activeElement !== n) return;
}
W(dt, "focusFirst");
function ft(e) {
	let t = pt(e);
	return [mt(t, e), mt(t.reverse(), e)];
}
W(ft, "getTabbableEdges");
function pt(e) {
	let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode: /* @__PURE__ */ W((e) => {
		let t = e.tagName === "INPUT" && e.type === "hidden";
		return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
	}, "acceptNode") });
	for (; n.nextNode();) t.push(n.currentNode);
	return t;
}
W(pt, "getTabbableCandidates");
function mt(e, t) {
	let n = typeof t.checkVisibility == "function" && t.checkVisibility({ checkVisibilityCSS: !0 });
	for (let r of e) if (!(n ? !r.checkVisibility({ checkVisibilityCSS: !0 }) : ht(r, { upTo: t }))) return r;
}
W(mt, "findVisible");
function ht(e, { upTo: t }) {
	if (getComputedStyle(e).visibility === "hidden") return !0;
	for (; e;) {
		if (t !== void 0 && e === t) return !1;
		if (getComputedStyle(e).display === "none") return !0;
		e = e.parentElement;
	}
	return !1;
}
W(ht, "isHidden");
function gt(e) {
	return e instanceof HTMLInputElement && "select" in e;
}
W(gt, "isSelectableInput");
function _t(e, { select: t = !1 } = {}) {
	if (e && e.focus) {
		let n = document.activeElement;
		e.focus({ preventScroll: !0 }), e !== n && gt(e) && t && e.select();
	}
}
W(_t, "focus");
var vt = yt();
function yt() {
	let e = [];
	return {
		add(t) {
			let n = e[0];
			t !== n && n?.pause(), e = bt(e, t), e.unshift(t);
		},
		remove(t) {
			e = bt(e, t), e[0]?.resume();
		}
	};
}
W(yt, "createFocusScopesStack");
function bt(e, t) {
	let n = [...e], r = n.indexOf(t);
	return r !== -1 && n.splice(r, 1), n;
}
W(bt, "arrayRemove");
function xt(e) {
	return e.filter((e) => e.tagName !== "A");
}
W(xt, "removeLinks");
// ../../../node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var St = globalThis?.document ? d.useLayoutEffect : () => {}, Ct = Object.defineProperty, wt = (e, t) => Ct(e, "name", {
	value: t,
	configurable: !0
}), Tt = d.useId || (() => void 0), Et = 0;
function Dt(e) {
	let [t, n] = d.useState(Tt());
	return St(() => {
		e || n((e) => e ?? String(Et++));
	}, [e]), e || (t ? `radix-${t}` : "");
}
wt(Dt, "useId");
// ../../../node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var Ot = [
	"top",
	"right",
	"bottom",
	"left"
], kt = Math.min, G = Math.max, At = Math.round, jt = Math.floor, Mt = (e) => ({
	x: e,
	y: e
}), Nt = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
};
function Pt(e, t, n) {
	return G(e, kt(t, n));
}
function Ft(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function It(e) {
	return e.split("-")[0];
}
function Lt(e) {
	return e.split("-")[1];
}
function Rt(e) {
	return e === "x" ? "y" : "x";
}
function zt(e) {
	return e === "y" ? "height" : "width";
}
function Bt(e) {
	let t = e[0];
	return t === "t" || t === "b" ? "y" : "x";
}
function Vt(e) {
	return Rt(Bt(e));
}
function Ht(e, t, n) {
	n === void 0 && (n = !1);
	let r = Lt(e), i = Vt(e), a = zt(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = Zt(o)), [o, Zt(o)];
}
function Ut(e) {
	let t = Zt(e);
	return [
		Wt(e),
		t,
		Wt(t)
	];
}
function Wt(e) {
	return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
var Gt = ["left", "right"], Kt = ["right", "left"], qt = ["top", "bottom"], Jt = ["bottom", "top"];
function Yt(e, t, n) {
	switch (e) {
		case "top":
		case "bottom": return n ? t ? Kt : Gt : t ? Gt : Kt;
		case "left":
		case "right": return t ? qt : Jt;
		default: return [];
	}
}
function Xt(e, t, n, r) {
	let i = Lt(e), a = Yt(It(e), n === "start", r);
	return i && (a = a.map((e) => e + "-" + i), t && (a = a.concat(a.map(Wt)))), a;
}
function Zt(e) {
	let t = It(e);
	return Nt[t] + e.slice(t.length);
}
function Qt(e) {
	return {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...e
	};
}
function $t(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : Qt(e);
}
function en(e) {
	let { x: t, y: n, width: r, height: i } = e;
	return {
		width: r,
		height: i,
		top: n,
		left: t,
		right: t + r,
		bottom: n + i,
		x: t,
		y: n
	};
}
// ../../../node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function tn(e, t, n) {
	let { reference: r, floating: i } = e, a = Bt(t), o = Vt(t), s = zt(o), c = It(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	switch (Lt(t)) {
		case "start":
			p[o] -= f * (n && l ? -1 : 1);
			break;
		case "end": p[o] += f * (n && l ? -1 : 1);
	}
	return p;
}
async function nn(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = Ft(t, e), p = $t(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = en(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		x: n,
		y: r,
		width: a.floating.width,
		height: a.floating.height
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = en(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		elements: o,
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var rn = 50, an = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = o.detectOverflow ? o : {
		...o,
		detectOverflow: nn
	}, c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = tn(l, r, c), f = r, p = 0, m = {};
	for (let n = 0; n < a.length; n++) {
		let h = a[n];
		if (!h) continue;
		let { name: g, fn: _ } = h, { x: v, y, data: b, reset: x } = await _({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: m,
			rects: l,
			platform: s,
			elements: {
				reference: e,
				floating: t
			}
		});
		u = v ?? u, d = y ?? d, m[g] = {
			...m[g],
			...b
		}, x && p < rn && (p++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (l = x.rects === !0 ? await o.getElementRects({
			reference: e,
			floating: t,
			strategy: i
		}) : x.rects), {x: u, y: d} = tn(l, f, c)), n = -1);
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: m
	};
}, on = (e) => ({
	name: "arrow",
	options: e,
	async fn(t) {
		let { x: n, y: r, placement: i, rects: a, platform: o, elements: s, middlewareData: c } = t, { element: l, padding: u = 0 } = Ft(e, t) || {};
		if (l == null) return {};
		let d = $t(u), f = {
			x: n,
			y: r
		}, p = Vt(i), m = zt(p), h = await o.getDimensions(l), g = p === "y", _ = g ? "top" : "left", v = g ? "bottom" : "right", y = g ? "clientHeight" : "clientWidth", b = a.reference[m] + a.reference[p] - f[p] - a.floating[m], x = f[p] - a.reference[p], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l)), C = S ? S[y] : 0;
		C && await (o.isElement == null ? void 0 : o.isElement(S)) || (C = s.floating[y] || a.floating[m]);
		let w = b / 2 - x / 2, T = C / 2 - h[m] / 2 - 1, E = kt(d[_], T), D = kt(d[v], T), O = E, k = C - h[m] - D, A = C / 2 - h[m] / 2 + w, j = Pt(O, A, k), M = !c.arrow && Lt(i) != null && A !== j && a.reference[m] / 2 - (A < O ? E : D) - h[m] / 2 < 0, ee = M ? A < O ? A - O : A - k : 0;
		return {
			[p]: f[p] + ee,
			data: {
				[p]: j,
				centerOffset: A - j - ee,
				...M && { alignmentOffset: ee }
			},
			reset: M
		};
	}
}), sn = function(e) {
	return e === void 0 && (e = {}), {
		name: "flip",
		options: e,
		async fn(t) {
			var n;
			let { placement: r, middlewareData: i, rects: a, initialPlacement: o, platform: s, elements: c } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: d, fallbackStrategy: f = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: m = !0, ...h } = Ft(e, t);
			if ((n = i.arrow) != null && n.alignmentOffset) return {};
			let g = It(r), _ = Bt(o), v = It(o) === o, y = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), b = d || (v || !m ? [Zt(o)] : Ut(o)), x = p !== "none";
			!d && x && b.push(...Xt(o, m, p, y));
			let S = [o, ...b], C = await s.detectOverflow(t, h), w = [], T = i.flip?.overflows || [];
			if (l && w.push(C[g]), u) {
				let e = Ht(r, a, y);
				w.push(C[e[0]], C[e[1]]);
			}
			if (T = [...T, {
				placement: r,
				overflows: w
			}], !w.every((e) => e <= 0)) {
				let e = (i.flip?.index || 0) + 1, t = S[e];
				if (t && (u !== "alignment" || _ === Bt(t) || T.every((e) => Bt(e.placement) !== _ || e.overflows[0] > 0))) return {
					data: {
						index: e,
						overflows: T
					},
					reset: { placement: t }
				};
				let n = T.filter((e) => e.overflows[0] <= 0).sort((e, t) => e.overflows[1] - t.overflows[1])[0]?.placement;
				if (!n) switch (f) {
					case "bestFit": {
						let e = T.filter((e) => {
							if (x) {
								let t = Bt(e.placement);
								return t === _ || t === "y";
							}
							return !0;
						}).map((e) => [e.placement, e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0)]).sort((e, t) => e[1] - t[1])[0]?.[0];
						e && (n = e);
						break;
					}
					case "initialPlacement": n = o;
				}
				if (r !== n) return { reset: { placement: n } };
			}
			return {};
		}
	};
};
function cn(e, t) {
	return {
		top: e.top - t.height,
		right: e.right - t.width,
		bottom: e.bottom - t.height,
		left: e.left - t.width
	};
}
function ln(e) {
	return Ot.some((t) => e[t] >= 0);
}
var un = function(e) {
	return e === void 0 && (e = {}), {
		name: "hide",
		options: e,
		async fn(t) {
			let { rects: n, platform: r } = t, { strategy: i = "referenceHidden", ...a } = Ft(e, t);
			switch (i) {
				case "referenceHidden": {
					let e = cn(await r.detectOverflow(t, {
						...a,
						elementContext: "reference"
					}), n.reference);
					return { data: {
						referenceHiddenOffsets: e,
						referenceHidden: ln(e)
					} };
				}
				case "escaped": {
					let e = cn(await r.detectOverflow(t, {
						...a,
						altBoundary: !0
					}), n.floating);
					return { data: {
						escapedOffsets: e,
						escaped: ln(e)
					} };
				}
				default: return {};
			}
		}
	};
}, dn = /*#__PURE__*/ new Set(["left", "top"]);
async function fn(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = It(n), s = Lt(n), c = Bt(n) === "y", l = dn.has(o) ? -1 : 1, u = a && c ? -1 : 1, d = Ft(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: d.mainAxis || 0,
		crossAxis: d.crossAxis || 0,
		alignmentAxis: d.alignmentAxis
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var pn = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			var n;
			let { x: r, y: i, placement: a, middlewareData: o } = t, s = await fn(t, e);
			return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset ? {} : {
				x: r + s.x,
				y: i + s.y,
				data: {
					...s,
					placement: a
				}
			};
		}
	};
}, mn = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i, platform: a } = t, { mainAxis: o = !0, crossAxis: s = !1, limiter: c = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...l } = Ft(e, t), u = {
				x: n,
				y: r
			}, d = await a.detectOverflow(t, l), f = Bt(It(i)), p = Rt(f), m = u[p], h = u[f];
			if (o) {
				let e = p === "y" ? "top" : "left", t = p === "y" ? "bottom" : "right", n = m + d[e], r = m - d[t];
				m = Pt(n, m, r);
			}
			if (s) {
				let e = f === "y" ? "top" : "left", t = f === "y" ? "bottom" : "right", n = h + d[e], r = h - d[t];
				h = Pt(n, h, r);
			}
			let g = c.fn({
				...t,
				[p]: m,
				[f]: h
			});
			return {
				...g,
				data: {
					x: g.x - n,
					y: g.y - r,
					enabled: {
						[p]: o,
						[f]: s
					}
				}
			};
		}
	};
}, hn = function(e) {
	return e === void 0 && (e = {}), {
		options: e,
		fn(t) {
			let { x: n, y: r, placement: i, rects: a, middlewareData: o } = t, { offset: s = 0, mainAxis: c = !0, crossAxis: l = !0 } = Ft(e, t), u = {
				x: n,
				y: r
			}, d = Bt(i), f = Rt(d), p = u[f], m = u[d], h = Ft(s, t), g = typeof h == "number" ? {
				mainAxis: h,
				crossAxis: 0
			} : {
				mainAxis: 0,
				crossAxis: 0,
				...h
			};
			if (c) {
				let e = f === "y" ? "height" : "width", t = a.reference[f] - a.floating[e] + g.mainAxis, n = a.reference[f] + a.reference[e] - g.mainAxis;
				p < t ? p = t : p > n && (p = n);
			}
			if (l) {
				let e = f === "y" ? "width" : "height", t = dn.has(It(i)), n = a.reference[d] - a.floating[e] + (t && o.offset?.[d] || 0) + (t ? 0 : g.crossAxis), r = a.reference[d] + a.reference[e] + (t ? 0 : o.offset?.[d] || 0) - (t ? g.crossAxis : 0);
				m < n ? m = n : m > r && (m = r);
			}
			return {
				[f]: p,
				[d]: m
			};
		}
	};
}, gn = function(e) {
	return e === void 0 && (e = {}), {
		name: "size",
		options: e,
		async fn(t) {
			var n, r;
			let { placement: i, rects: a, platform: o, elements: s } = t, { apply: c = () => {}, ...l } = Ft(e, t), u = await o.detectOverflow(t, l), d = It(i), f = Lt(i), p = Bt(i) === "y", { width: m, height: h } = a.floating, g, _;
			d === "top" || d === "bottom" ? (g = d, _ = f === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (_ = d, g = f === "end" ? "top" : "bottom");
			let v = h - u.top - u.bottom, y = m - u.left - u.right, b = kt(h - u[g], v), x = kt(m - u[_], y), S = !t.middlewareData.shift, C = b, w = x;
			if ((n = t.middlewareData.shift) != null && n.enabled.x && (w = y), (r = t.middlewareData.shift) != null && r.enabled.y && (C = v), S && !f) {
				let e = G(u.left, 0), t = G(u.right, 0), n = G(u.top, 0), r = G(u.bottom, 0);
				p ? w = m - 2 * (e !== 0 || t !== 0 ? e + t : G(u.left, u.right)) : C = h - 2 * (n !== 0 || r !== 0 ? n + r : G(u.top, u.bottom));
			}
			await c({
				...t,
				availableWidth: w,
				availableHeight: C
			});
			let T = await o.getDimensions(s.floating);
			return m !== T.width || h !== T.height ? { reset: { rects: !0 } } : {};
		}
	};
};
// ../../../node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function _n() {
	return typeof window < "u";
}
function vn(e) {
	return bn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function K(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function yn(e) {
	return ((bn(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function bn(e) {
	return _n() ? e instanceof Node || e instanceof K(e).Node : !1;
}
function q(e) {
	return _n() ? e instanceof Element || e instanceof K(e).Element : !1;
}
function xn(e) {
	return _n() ? e instanceof HTMLElement || e instanceof K(e).HTMLElement : !1;
}
function Sn(e) {
	return !_n() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof K(e).ShadowRoot;
}
function Cn(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = J(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && i !== "inline" && i !== "contents";
}
function wn(e) {
	return /^(table|td|th)$/.test(vn(e));
}
function Tn(e) {
	try {
		if (e.matches(":popover-open")) return !0;
	} catch {}
	try {
		return e.matches(":modal");
	} catch {
		return !1;
	}
}
var En = /transform|translate|scale|rotate|perspective|filter/, Dn = /paint|layout|strict|content/, On = (e) => !!e && e !== "none", kn;
function An(e) {
	let t = q(e) ? J(e) : e;
	return On(t.transform) || On(t.translate) || On(t.scale) || On(t.rotate) || On(t.perspective) || !Mn() && (On(t.backdropFilter) || On(t.filter)) || En.test(t.willChange || "") || Dn.test(t.contain || "");
}
function jn(e) {
	let t = Fn(e);
	for (; xn(t) && !Nn(t);) {
		if (An(t)) return t;
		if (Tn(t)) return null;
		t = Fn(t);
	}
	return null;
}
function Mn() {
	return kn ??= typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none"), kn;
}
function Nn(e) {
	return /^(html|body|#document)$/.test(vn(e));
}
function J(e) {
	return K(e).getComputedStyle(e);
}
function Pn(e) {
	return q(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.scrollX,
		scrollTop: e.scrollY
	};
}
function Fn(e) {
	if (vn(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || Sn(e) && e.host || yn(e);
	return Sn(t) ? t.host : t;
}
function In(e) {
	let t = Fn(e);
	return Nn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : xn(t) && Cn(t) ? t : In(t);
}
function Ln(e, t, n) {
	t === void 0 && (t = []), n === void 0 && (n = !0);
	let r = In(e), i = r === e.ownerDocument?.body, a = K(r);
	if (i) {
		let e = Rn(a);
		return t.concat(a, a.visualViewport || [], Cn(r) ? r : [], e && n ? Ln(e) : []);
	}
	return t.concat(r, Ln(r, [], n));
}
function Rn(e) {
	return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
// ../../../node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function zn(e) {
	let t = J(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = xn(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = At(n) !== a || At(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function Bn(e) {
	return q(e) ? e : e.contextElement;
}
function Vn(e) {
	let t = Bn(e);
	if (!xn(t)) return Mt(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = zn(t), o = (a ? At(n.width) : n.width) / r, s = (a ? At(n.height) : n.height) / i;
	return o && Number.isFinite(o) || (o = 1), s && Number.isFinite(s) || (s = 1), {
		x: o,
		y: s
	};
}
var Hn = /*#__PURE__*/ Mt(0);
function Un(e) {
	let t = K(e);
	return !Mn() || !t.visualViewport ? Hn : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function Wn(e, t, n) {
	return t === void 0 && (t = !1), !n || t && n !== K(e) ? !1 : t;
}
function Gn(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = Bn(e), o = Mt(1);
	t && (r ? q(r) && (o = Vn(r)) : o = Vn(e));
	let s = Wn(a, n, r) ? Un(a) : Mt(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a) {
		let e = K(a), t = r && q(r) ? K(r) : r, n = e, i = Rn(n);
		for (; i && r && t !== n;) {
			let e = Vn(i), t = i.getBoundingClientRect(), r = J(i), a = t.left + (i.clientLeft + parseFloat(r.paddingLeft)) * e.x, o = t.top + (i.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += a, l += o, n = K(i), i = Rn(n);
		}
	}
	return en({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function Kn(e, t) {
	let n = Pn(e).scrollLeft;
	return t ? t.left + n : Gn(yn(e)).left + n;
}
function qn(e, t) {
	let n = e.getBoundingClientRect();
	return {
		x: n.left + t.scrollLeft - Kn(e, n),
		y: n.top + t.scrollTop
	};
}
function Jn(e) {
	let { elements: t, rect: n, offsetParent: r, strategy: i } = e, a = i === "fixed", o = yn(r), s = t ? Tn(t.floating) : !1;
	if (r === o || s && a) return n;
	let c = {
		scrollLeft: 0,
		scrollTop: 0
	}, l = Mt(1), u = Mt(0), d = xn(r);
	if ((d || !d && !a) && ((vn(r) !== "body" || Cn(o)) && (c = Pn(r)), d)) {
		let e = Gn(r);
		l = Vn(r), u.x = e.x + r.clientLeft, u.y = e.y + r.clientTop;
	}
	let f = o && !d && !a ? qn(o, c) : Mt(0);
	return {
		width: n.width * l.x,
		height: n.height * l.y,
		x: n.x * l.x - c.scrollLeft * l.x + u.x + f.x,
		y: n.y * l.y - c.scrollTop * l.y + u.y + f.y
	};
}
function Yn(e) {
	return Array.from(e.getClientRects());
}
function Xn(e) {
	let t = yn(e), n = Pn(e), r = e.ownerDocument.body, i = G(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = G(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight), o = -n.scrollLeft + Kn(e), s = -n.scrollTop;
	return J(r).direction === "rtl" && (o += G(t.clientWidth, r.clientWidth) - i), {
		width: i,
		height: a,
		x: o,
		y: s
	};
}
var Zn = 25;
function Qn(e, t) {
	let n = K(e), r = yn(e), i = n.visualViewport, a = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
	if (i) {
		a = i.width, o = i.height;
		let e = Mn();
		(!e || e && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
	}
	let l = Kn(r);
	if (l <= 0) {
		let e = r.ownerDocument, t = e.body, n = getComputedStyle(t), i = e.compatMode === "CSS1Compat" && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, o = Math.abs(r.clientWidth - t.clientWidth - i);
		o <= Zn && (a -= o);
	} else l <= Zn && (a += l);
	return {
		width: a,
		height: o,
		x: s,
		y: c
	};
}
function $n(e, t) {
	let n = Gn(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = xn(e) ? Vn(e) : Mt(1);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function er(e, t, n) {
	let r;
	if (t === "viewport") r = Qn(e, n);
	else if (t === "document") r = Xn(yn(e));
	else if (q(t)) r = $n(t, n);
	else {
		let n = Un(e);
		r = {
			x: t.x - n.x,
			y: t.y - n.y,
			width: t.width,
			height: t.height
		};
	}
	return en(r);
}
function tr(e, t) {
	let n = Fn(e);
	return n === t || !q(n) || Nn(n) ? !1 : J(n).position === "fixed" || tr(n, t);
}
function nr(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = Ln(e, [], !1).filter((e) => q(e) && vn(e) !== "body"), i = null, a = J(e).position === "fixed", o = a ? Fn(e) : e;
	for (; q(o) && !Nn(o);) {
		let t = J(o), n = An(o);
		!n && t.position === "fixed" && (i = null), (a ? !n && !i : !n && t.position === "static" && i && (i.position === "absolute" || i.position === "fixed") || Cn(o) && !n && tr(e, o)) ? r = r.filter((e) => e !== o) : i = t, o = Fn(o);
	}
	return t.set(e, r), r;
}
function rr(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? Tn(t) ? [] : nr(t, this._c) : [].concat(n), r], o = er(t, a[0], i), s = o.top, c = o.right, l = o.bottom, u = o.left;
	for (let e = 1; e < a.length; e++) {
		let n = er(t, a[e], i);
		s = G(n.top, s), c = kt(n.right, c), l = kt(n.bottom, l), u = G(n.left, u);
	}
	return {
		width: c - u,
		height: l - s,
		x: u,
		y: s
	};
}
function ir(e) {
	let { width: t, height: n } = zn(e);
	return {
		width: t,
		height: n
	};
}
function ar(e, t, n) {
	let r = xn(t), i = yn(t), a = n === "fixed", o = Gn(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = Mt(0);
	function l() {
		c.x = Kn(i);
	}
	if (r || !r && !a) {
		if ((vn(t) !== "body" || Cn(i)) && (s = Pn(t)), r) {
			let e = Gn(t, !0, a, t);
			c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
		} else i && l();
	}
	a && !r && i && l();
	let u = i && !r && !a ? qn(i, s) : Mt(0);
	return {
		x: o.left + s.scrollLeft - c.x - u.x,
		y: o.top + s.scrollTop - c.y - u.y,
		width: o.width,
		height: o.height
	};
}
function or(e) {
	return J(e).position === "static";
}
function sr(e, t) {
	if (!xn(e) || J(e).position === "fixed") return null;
	if (t) return t(e);
	let n = e.offsetParent;
	return yn(e) === n && (n = n.ownerDocument.body), n;
}
function cr(e, t) {
	let n = K(e);
	if (Tn(e)) return n;
	if (!xn(e)) {
		let t = Fn(e);
		for (; t && !Nn(t);) {
			if (q(t) && !or(t)) return t;
			t = Fn(t);
		}
		return n;
	}
	let r = sr(e, t);
	for (; r && wn(r) && or(r);) r = sr(r, t);
	return r && Nn(r) && or(r) && !An(r) ? n : r || jn(e) || n;
}
var lr = async function(e) {
	let t = this.getOffsetParent || cr, n = this.getDimensions, r = await n(e.floating);
	return {
		reference: ar(e.reference, await t(e.floating), e.strategy),
		floating: {
			x: 0,
			y: 0,
			width: r.width,
			height: r.height
		}
	};
};
function ur(e) {
	return J(e).direction === "rtl";
}
var dr = {
	convertOffsetParentRelativeRectToViewportRelativeRect: Jn,
	getDocumentElement: yn,
	getClippingRect: rr,
	getOffsetParent: cr,
	getElementRects: lr,
	getClientRects: Yn,
	getDimensions: ir,
	getScale: Vn,
	isElement: q,
	isRTL: ur
};
function fr(e, t) {
	return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function pr(e, t) {
	let n = null, r, i = yn(e);
	function a() {
		var e;
		clearTimeout(r), (e = n) == null || e.disconnect(), n = null;
	}
	function o(s, c) {
		s === void 0 && (s = !1), c === void 0 && (c = 1), a();
		let l = e.getBoundingClientRect(), { left: u, top: d, width: f, height: p } = l;
		if (s || t(), !f || !p) return;
		let m = jt(d), h = jt(i.clientWidth - (u + f)), g = jt(i.clientHeight - (d + p)), _ = jt(u), v = {
			rootMargin: -m + "px " + -h + "px " + -g + "px " + -_ + "px",
			threshold: G(0, kt(1, c)) || 1
		}, y = !0;
		function b(t) {
			let n = t[0].intersectionRatio;
			if (n !== c) {
				if (!y) return o();
				n ? o(!1, n) : r = setTimeout(() => {
					o(!1, 1e-7);
				}, 1e3);
			}
			n === 1 && !fr(l, e.getBoundingClientRect()) && o(), y = !1;
		}
		try {
			n = new IntersectionObserver(b, {
				...v,
				root: i.ownerDocument
			});
		} catch {
			n = new IntersectionObserver(b, v);
		}
		n.observe(e);
	}
	return o(!0), a;
}
function mr(e, t, n, r) {
	r === void 0 && (r = {});
	let { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = Bn(e), u = i || a ? [...l ? Ln(l) : [], ...t ? Ln(t) : []] : [];
	u.forEach((e) => {
		i && e.addEventListener("scroll", n, { passive: !0 }), a && e.addEventListener("resize", n);
	});
	let d = l && s ? pr(l, n) : null, f = -1, p = null;
	o && (p = new ResizeObserver((e) => {
		let [r] = e;
		r && r.target === l && p && t && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
			var e;
			(e = p) == null || e.observe(t);
		})), n();
	}), l && !c && p.observe(l), t && p.observe(t));
	let m, h = c ? Gn(e) : null;
	c && g();
	function g() {
		let t = Gn(e);
		h && !fr(h, t) && n(), h = t, m = requestAnimationFrame(g);
	}
	return n(), () => {
		var e;
		u.forEach((e) => {
			i && e.removeEventListener("scroll", n), a && e.removeEventListener("resize", n);
		}), d?.(), (e = p) == null || e.disconnect(), p = null, c && cancelAnimationFrame(m);
	};
}
var hr = pn, gr = mn, _r = sn, vr = gn, yr = un, br = on, xr = hn, Sr = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = {
		platform: dr,
		...n
	}, a = {
		...i.platform,
		_c: r
	};
	return an(e, t, {
		...i,
		platform: a
	});
}, Cr = typeof document < "u" ? h : function() {};
function wr(e, t) {
	if (e === t) return !0;
	if (typeof e != typeof t) return !1;
	if (typeof e == "function" && e.toString() === t.toString()) return !0;
	let n, r, i;
	if (e && t && typeof e == "object") {
		if (Array.isArray(e)) {
			if (n = e.length, n !== t.length) return !1;
			for (r = n; r-- !== 0;) if (!wr(e[r], t[r])) return !1;
			return !0;
		}
		if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length) return !1;
		for (r = n; r-- !== 0;) if (!{}.hasOwnProperty.call(t, i[r])) return !1;
		for (r = n; r-- !== 0;) {
			let n = i[r];
			if (!(n === "_owner" && e.$$typeof) && !wr(e[n], t[n])) return !1;
		}
		return !0;
	}
	return e !== e && t !== t;
}
function Tr(e) {
	return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Er(e, t) {
	let n = Tr(e);
	return Math.round(t * n) / n;
}
function Dr(e) {
	let t = d.useRef(e);
	return Cr(() => {
		t.current = e;
	}), t;
}
function Or(e) {
	e === void 0 && (e = {});
	let { placement: t = "bottom", strategy: n = "absolute", middleware: r = [], platform: i, elements: { reference: a, floating: o } = {}, transform: s = !0, whileElementsMounted: c, open: l } = e, [u, f] = d.useState({
		x: 0,
		y: 0,
		strategy: n,
		placement: t,
		middlewareData: {},
		isPositioned: !1
	}), [p, m] = d.useState(r);
	wr(p, r) || m(r);
	let [h, g] = d.useState(null), [_, v] = d.useState(null), y = d.useCallback((e) => {
		e !== w.current && (w.current = e, g(e));
	}, []), b = d.useCallback((e) => {
		e !== T.current && (T.current = e, v(e));
	}, []), x = a || h, C = o || _, w = d.useRef(null), T = d.useRef(null), E = d.useRef(u), D = c != null, O = Dr(c), k = Dr(i), A = Dr(l), j = d.useCallback(() => {
		if (!w.current || !T.current) return;
		let e = {
			placement: t,
			strategy: n,
			middleware: p
		};
		k.current && (e.platform = k.current), Sr(w.current, T.current, e).then((e) => {
			let t = {
				...e,
				isPositioned: A.current !== !1
			};
			M.current && !wr(E.current, t) && (E.current = t, S.flushSync(() => {
				f(t);
			}));
		});
	}, [
		p,
		t,
		n,
		k,
		A
	]);
	Cr(() => {
		l === !1 && E.current.isPositioned && (E.current.isPositioned = !1, f((e) => ({
			...e,
			isPositioned: !1
		})));
	}, [l]);
	let M = d.useRef(!1);
	Cr(() => (M.current = !0, () => {
		M.current = !1;
	}), []), Cr(() => {
		if (x && (w.current = x), C && (T.current = C), x && C) {
			if (O.current) return O.current(x, C, j);
			j();
		}
	}, [
		x,
		C,
		j,
		O,
		D
	]);
	let ee = d.useMemo(() => ({
		reference: w,
		floating: T,
		setReference: y,
		setFloating: b
	}), [y, b]), N = d.useMemo(() => ({
		reference: x,
		floating: C
	}), [x, C]), te = d.useMemo(() => {
		let e = {
			position: n,
			left: 0,
			top: 0
		};
		if (!N.floating) return e;
		let t = Er(N.floating, u.x), r = Er(N.floating, u.y);
		return s ? {
			...e,
			transform: "translate(" + t + "px, " + r + "px)",
			...Tr(N.floating) >= 1.5 && { willChange: "transform" }
		} : {
			position: n,
			left: t,
			top: r
		};
	}, [
		n,
		s,
		N.floating,
		u.x,
		u.y
	]);
	return d.useMemo(() => ({
		...u,
		update: j,
		refs: ee,
		elements: N,
		floatingStyles: te
	}), [
		u,
		j,
		ee,
		N,
		te
	]);
}
var kr = (e) => {
	function t(e) {
		return {}.hasOwnProperty.call(e, "current");
	}
	return {
		name: "arrow",
		options: e,
		fn(n) {
			let { element: r, padding: i } = typeof e == "function" ? e(n) : e;
			return r && t(r) ? r.current == null ? {} : br({
				element: r.current,
				padding: i
			}).fn(n) : r ? br({
				element: r,
				padding: i
			}).fn(n) : {};
		}
	};
}, Ar = (e, t) => {
	let n = hr(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, jr = (e, t) => {
	let n = gr(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Mr = (e, t) => ({
	fn: xr(e).fn,
	options: [e, t]
}), Nr = (e, t) => {
	let n = _r(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Pr = (e, t) => {
	let n = vr(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Fr = (e, t) => {
	let n = yr(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Ir = (e, t) => {
	let n = kr(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Lr = Object.defineProperty, Rr = (e, t) => Lr(e, "name", {
	value: t,
	configurable: !0
});
function zr(e) {
	let [t, n] = d.useState(void 0);
	return St(() => {
		if (e) {
			n({
				width: e.offsetWidth,
				height: e.offsetHeight
			});
			let t = new ResizeObserver((t) => {
				if (!Array.isArray(t) || !t.length) return;
				let r = t[0], i, a;
				if ("borderBoxSize" in r) {
					let e = r.borderBoxSize, t = Array.isArray(e) ? e[0] : e;
					i = t.inlineSize, a = t.blockSize;
				} else i = e.offsetWidth, a = e.offsetHeight;
				n({
					width: i,
					height: a
				});
			});
			return t.observe(e, { box: "border-box" }), () => t.unobserve(e);
		}
		n(void 0);
	}, [e]), t;
}
Rr(zr, "useSize");
// ../../../node_modules/@radix-ui/react-popper/dist/index.mjs
var Br = Object.defineProperty, Vr = (e, t) => Br(e, "name", {
	value: t,
	configurable: !0
}), Hr = "Popper", [Ur, Wr] = /* @__PURE__ */ be(Hr), [Gr, Kr] = Ur(Hr), qr = /* @__PURE__ */ Vr((e) => {
	let { __scopePopper: t, children: n } = e, [r, i] = d.useState(null), [a, o] = d.useState(void 0);
	return /* @__PURE__ */ b(Gr, {
		scope: t,
		anchor: r,
		onAnchorChange: i,
		placementState: a,
		setPlacementState: o,
		children: n
	});
}, "Popper"), Jr = "PopperAnchor", Yr = /* @__PURE__ */ d.forwardRef(/* @__PURE__ */ Vr(function(e, t) {
	let { __scopePopper: n, virtualRef: r, ...i } = e, a = Kr(Jr, n), o = d.useRef(null), s = a.onAnchorChange, c = _e(t, d.useCallback((e) => {
		o.current = e, e && s(e);
	}, [s])), l = d.useRef(null);
	d.useEffect(() => {
		if (!r) return;
		let e = l.current;
		l.current = r.current, e !== l.current && s(l.current);
	});
	let u = a.placementState && ni(a.placementState), f = u?.[0], p = u?.[1];
	return r ? null : /* @__PURE__ */ b(V.div, {
		"data-radix-popper-side": f,
		"data-radix-popper-align": p,
		...i,
		ref: c
	});
}, "PopperAnchor")), Xr = "PopperContent", [Zr, Qr] = Ur(Xr), $r = /* @__PURE__ */ d.forwardRef(/* @__PURE__ */ Vr(function(e, t) {
	let { __scopePopper: n, side: r = "bottom", sideOffset: i = 0, align: a = "center", alignOffset: o = 0, arrowPadding: s = 0, avoidCollisions: c = !0, collisionBoundary: l = [], collisionPadding: u = 0, sticky: f = "partial", hideWhenDetached: p = !1, updatePositionStrategy: m = "optimized", onPlaced: h, ...g } = e, _ = Kr(Xr, n), [v, y] = d.useState(null), x = _e(t, y), [S, C] = d.useState(null), w = zr(S), T = w?.width ?? 0, E = w?.height ?? 0, D = r + (a === "center" ? "" : "-" + a), O = typeof u == "number" ? u : {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...u
	}, k = Array.isArray(l) ? l : [l], A = k.length > 0, j = {
		padding: O,
		boundary: k.filter(ei),
		altBoundary: A
	}, { refs: M, floatingStyles: ee, placement: N, isPositioned: te, middlewareData: ne } = Or({
		strategy: "fixed",
		placement: D,
		whileElementsMounted: /* @__PURE__ */ Vr((...e) => mr(...e, { animationFrame: m === "always" }), "whileElementsMounted"),
		elements: { reference: _.anchor },
		middleware: [
			Ar({
				mainAxis: i + E,
				alignmentAxis: o
			}),
			c && jr({
				mainAxis: !0,
				crossAxis: !1,
				limiter: f === "partial" ? Mr() : void 0,
				...j
			}),
			c && Nr({ ...j }),
			Pr({
				...j,
				apply: /* @__PURE__ */ Vr(({ elements: e, rects: t, availableWidth: n, availableHeight: r }) => {
					let { width: i, height: a } = t.reference, o = e.floating.style;
					o.setProperty("--radix-popper-available-width", `${n}px`), o.setProperty("--radix-popper-available-height", `${r}px`), o.setProperty("--radix-popper-anchor-width", `${i}px`), o.setProperty("--radix-popper-anchor-height", `${a}px`);
				}, "apply")
			}),
			S && Ir({
				element: S,
				padding: s
			}),
			ti({
				arrowWidth: T,
				arrowHeight: E
			}),
			p && Fr({
				strategy: "referenceHidden",
				...j,
				boundary: A ? j.boundary : void 0
			})
		]
	}), re = _.setPlacementState;
	St(() => (re(N), () => {
		re(void 0);
	}), [N, re]);
	let [ie, ae] = ni(N), oe = H(h);
	St(() => {
		te && oe?.();
	}, [te, oe]);
	let se = ne.arrow?.x, ce = ne.arrow?.y, le = ne.arrow?.centerOffset !== 0, [ue, de] = d.useState();
	return St(() => {
		v && de(window.getComputedStyle(v).zIndex);
	}, [v]), /* @__PURE__ */ b("div", {
		ref: M.setFloating,
		"data-radix-popper-content-wrapper": "",
		style: {
			...ee,
			transform: te ? ee.transform : "translate(0, -200%)",
			minWidth: "max-content",
			zIndex: ue,
			"--radix-popper-transform-origin": [ne.transformOrigin?.x, ne.transformOrigin?.y].join(" "),
			...ne.hide?.referenceHidden && {
				visibility: "hidden",
				pointerEvents: "none"
			}
		},
		dir: e.dir,
		children: /* @__PURE__ */ b(Zr, {
			scope: n,
			placedSide: ie,
			placedAlign: ae,
			onArrowChange: C,
			arrowX: se,
			arrowY: ce,
			shouldHideArrow: le,
			children: /* @__PURE__ */ b(V.div, {
				"data-side": ie,
				"data-align": ae,
				...g,
				ref: x,
				style: {
					...g.style,
					animation: te ? g.style?.animation : "none"
				}
			})
		})
	});
}, "PopperContent"));
function ei(e) {
	return e !== null;
}
Vr(ei, "isNotNull");
var ti = /* @__PURE__ */ Vr((e) => ({
	name: "transformOrigin",
	options: e,
	fn(t) {
		let { placement: n, rects: r, middlewareData: i } = t, a = i.arrow?.centerOffset !== 0, o = a ? 0 : e.arrowWidth, s = a ? 0 : e.arrowHeight, [c, l] = ni(n), u = {
			start: "0%",
			center: "50%",
			end: "100%"
		}[l], d = (i.arrow?.x ?? 0) + o / 2, f = (i.arrow?.y ?? 0) + s / 2, p = "", m = "";
		return c === "bottom" ? (p = a ? u : `${d}px`, m = `${-s}px`) : c === "top" ? (p = a ? u : `${d}px`, m = `${r.floating.height + s}px`) : c === "right" ? (p = `${-s}px`, m = a ? u : `${f}px`) : c === "left" && (p = `${r.floating.width + s}px`, m = a ? u : `${f}px`), { data: {
			x: p,
			y: m
		} };
	}
}), "transformOrigin");
function ni(e) {
	let [t, n = "center"] = e.split("-");
	return [t, n];
}
Vr(ni, "getSideAndAlignFromPlacement");
var ri = qr, ii = Yr, ai = $r, oi = Object.defineProperty, si = /* @__PURE__ */ d.forwardRef(/* @__PURE__ */ ((e, t) => oi(e, "name", {
	value: t,
	configurable: !0
}))(function(e, t) {
	let { container: n, ...r } = e, [i, a] = d.useState(!1);
	St(() => a(!0), []);
	let o = n || i && globalThis?.document?.body;
	return o ? S.createPortal(/* @__PURE__ */ b(V.div, {
		...r,
		ref: t
	}), o) : null;
}, "Portal")), ci = Object.defineProperty, li = (e, t) => ci(e, "name", {
	value: t,
	configurable: !0
});
function ui(e, t) {
	return d.useReducer((e, n) => t[e][n] ?? e, e);
}
li(ui, "useStateMachine");
var di = /* @__PURE__ */ li((e) => {
	let { present: t, children: n } = e, r = fi(t), i = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), a = mi(r.ref, gi(i));
	return typeof n == "function" || r.isPresent ? d.cloneElement(i, { ref: a }) : null;
}, "Presence");
function fi(e) {
	let [t, n] = d.useState(), r = d.useRef(null), i = d.useRef(e), a = d.useRef("none"), o = d.useRef(void 0), [s, c] = ui(e ? "mounted" : "unmounted", {
		mounted: {
			UNMOUNT: "unmounted",
			ANIMATION_OUT: "unmountSuspended"
		},
		unmountSuspended: {
			MOUNT: "mounted",
			ANIMATION_END: "unmounted"
		},
		unmounted: { MOUNT: "mounted" }
	});
	return d.useEffect(() => {
		s === "mounted" ? (a.current = o.current ?? hi(r.current), o.current = void 0) : a.current = "none";
	}, [s]), St(() => {
		let t = r.current, n = i.current;
		if (n !== e) {
			let r = a.current, s = hi(t);
			e ? (o.current = s, c("MOUNT")) : s === "none" || t?.display === "none" ? c("UNMOUNT") : c(n && r !== s ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
		}
	}, [e, c]), St(() => {
		if (t) {
			let e, n = t.ownerDocument.defaultView ?? window, o = /* @__PURE__ */ li((a) => {
				let o = hi(r.current).includes(CSS.escape(a.animationName));
				if (a.target === t && o && (c("ANIMATION_END"), !i.current)) {
					let r = t.style.animationFillMode;
					t.style.animationFillMode = "forwards", e = n.setTimeout(() => {
						t.style.animationFillMode === "forwards" && (t.style.animationFillMode = r);
					});
				}
			}, "handleAnimationEnd"), s = /* @__PURE__ */ li((e) => {
				e.target === t && (a.current = hi(r.current));
			}, "handleAnimationStart");
			return t.addEventListener("animationstart", s), t.addEventListener("animationcancel", o), t.addEventListener("animationend", o), () => {
				n.clearTimeout(e), t.removeEventListener("animationstart", s), t.removeEventListener("animationcancel", o), t.removeEventListener("animationend", o);
			};
		}
		c("ANIMATION_END");
	}, [t, c]), {
		isPresent: ["mounted", "unmountSuspended"].includes(s),
		ref: d.useCallback((e) => {
			if (e) {
				let t = getComputedStyle(e);
				r.current = t, o.current = hi(t);
			} else r.current = null;
			n(e);
		}, [])
	};
}
li(fi, "usePresence");
function pi(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
li(pi, "setRef");
function mi(...e) {
	let t = d.useRef(e);
	return t.current = e, d.useCallback((e) => {
		let n = t.current, r = !1, i = n.map((t) => {
			let n = pi(t, e);
			return !r && typeof n == "function" && (r = !0), n;
		});
		if (r) return () => {
			for (let e = 0; e < i.length; e++) {
				let t = i[e];
				typeof t == "function" ? t() : pi(n[e], null);
			}
		};
	}, []);
}
li(mi, "useStableComposedRefs");
function hi(e) {
	return e?.animationName || "none";
}
li(hi, "getAnimationName");
function gi(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
li(gi, "getElementRef");
// ../../../node_modules/@radix-ui/react-use-effect-event/dist/index.mjs
var _i = Object.defineProperty, vi = (e, t) => _i(e, "name", {
	value: t,
	configurable: !0
}), yi = d.useEffectEvent, bi = d.useInsertionEffect;
function xi(e) {
	if (typeof yi == "function") return yi(e);
	let t = d.useRef(() => {
		throw Error("Cannot call an event handler while rendering.");
	});
	return typeof bi == "function" ? bi(() => {
		t.current = e;
	}) : St(() => {
		t.current = e;
	}), d.useMemo(() => ((...e) => t.current?.(...e)), []);
}
vi(xi, "useEffectEvent");
// ../../../node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var Si = Object.defineProperty, Ci = (e, t) => Si(e, "name", {
	value: t,
	configurable: !0
}), wi = d.useInsertionEffect || St;
function Ti({ prop: e, defaultProp: t, onChange: n = /* @__PURE__ */ Ci(() => {}, "onChange"), caller: r }) {
	let [i, a, o] = Ei({
		defaultProp: t,
		onChange: n
	}), s = e !== void 0;
	return [s ? e : i, d.useCallback((t) => {
		if (s) {
			let n = Di(t) ? t(e) : t;
			n !== e && o.current?.(n);
		} else a(t);
	}, [
		s,
		e,
		a,
		o
	])];
}
Ci(Ti, "useControllableState");
function Ei({ defaultProp: e, onChange: t }) {
	let [n, r] = d.useState(e), i = d.useRef(n), a = d.useRef(t);
	return wi(() => {
		a.current = t;
	}, [t]), d.useEffect(() => {
		i.current !== n && (a.current?.(n), i.current = n);
	}, [n, i]), [
		n,
		r,
		a
	];
}
Ci(Ei, "useUncontrolledState");
function Di(e) {
	return typeof e == "function";
}
Ci(Di, "isFunction");
var Oi = Symbol("RADIX:SYNC_STATE");
function ki(e, t, n, r) {
	let { prop: i, defaultProp: a, onChange: o, caller: s } = t, c = i !== void 0, l = xi(o), u = [{
		...n,
		state: a
	}];
	r && u.push(r);
	let [f, p] = d.useReducer((t, n) => {
		if (n.type === Oi) return {
			...t,
			state: n.state
		};
		let r = e(t, n);
		return c && !Object.is(r.state, t.state) && l(r.state), r;
	}, ...u), m = f.state, h = d.useRef(m);
	d.useEffect(() => {
		h.current !== m && (h.current = m, c || l(m));
	}, [
		m,
		h,
		c
	]);
	let g = d.useMemo(() => i === void 0 ? f : {
		...f,
		state: i
	}, [f, i]);
	return d.useEffect(() => {
		c && !Object.is(i, f.state) && p({
			type: Oi,
			state: i
		});
	}, [
		i,
		f.state,
		c
	]), [g, p];
}
Ci(ki, "useControllableStateReducer");
// ../../../node_modules/aria-hidden/dist/es2015/index.js
var Ai = function(e) {
	return typeof document > "u" ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body;
}, ji = /* @__PURE__ */ new WeakMap(), Mi = /* @__PURE__ */ new WeakMap(), Ni = {}, Pi = 0, Fi = function(e) {
	return e && (e.host || Fi(e.parentNode));
}, Ii = function(e, t) {
	return t.map(function(t) {
		if (e.contains(t)) return t;
		var n = Fi(t);
		return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
	}).filter(function(e) {
		return !!e;
	});
}, Li = function(e, t, n, r) {
	var i = Ii(t, Array.isArray(e) ? e : [e]);
	Ni[n] || (Ni[n] = /* @__PURE__ */ new WeakMap());
	var a = Ni[n], o = [], s = /* @__PURE__ */ new Set(), c = new Set(i), l = function(e) {
		e && !s.has(e) && (s.add(e), l(e.parentNode));
	};
	i.forEach(l);
	var u = function(e) {
		e && !c.has(e) && Array.prototype.forEach.call(e.children, function(e) {
			if (s.has(e)) u(e);
			else try {
				var t = e.getAttribute(r), i = t !== null && t !== "false", c = (ji.get(e) || 0) + 1, l = (a.get(e) || 0) + 1;
				ji.set(e, c), a.set(e, l), o.push(e), c === 1 && i && Mi.set(e, !0), l === 1 && e.setAttribute(n, "true"), i || e.setAttribute(r, "true");
			} catch (t) {
				console.error("aria-hidden: cannot operate on ", e, t);
			}
		});
	};
	return u(t), s.clear(), Pi++, function() {
		o.forEach(function(e) {
			var t = ji.get(e) - 1, i = a.get(e) - 1;
			ji.set(e, t), a.set(e, i), t || (Mi.has(e) || e.removeAttribute(r), Mi.delete(e)), i || e.removeAttribute(n);
		}), Pi--, Pi || (ji = /* @__PURE__ */ new WeakMap(), ji = /* @__PURE__ */ new WeakMap(), Mi = /* @__PURE__ */ new WeakMap(), Ni = {});
	};
}, Ri = function(e, t, n) {
	n === void 0 && (n = "data-aria-hidden");
	var r = Array.from(Array.isArray(e) ? e : [e]), i = t || Ai(e);
	return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live], script"))), Li(r, i, n, "aria-hidden")) : function() {
		return null;
	};
};
// ../../../node_modules/tslib/tslib.es6.mjs
function zi(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
function Bi(e, t, n) {
	if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
	return e.concat(a || Array.prototype.slice.call(t));
}
var Y, Vi = ce((() => {
	Y = function() {
		return Y = Object.assign || function(e) {
			for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
			return e;
		}, Y.apply(this, arguments);
	};
})), Hi = "right-scroll-bar-position", Ui = "width-before-scroll-bar", Wi = "with-scroll-bars-hidden", Gi = "--removed-body-scroll-bar-size";
// ../../../node_modules/use-callback-ref/dist/es2015/assignRef.js
function Ki(e, t) {
	return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
// ../../../node_modules/use-callback-ref/dist/es2015/useRef.js
function qi(e, t) {
	var n = v(function() {
		return {
			value: e,
			callback: t,
			facade: {
				get current() {
					return n.value;
				},
				set current(e) {
					var t = n.value;
					t !== e && (n.value = e, n.callback(e, t));
				}
			}
		};
	})[0];
	return n.callback = t, n.facade;
}
// ../../../node_modules/use-callback-ref/dist/es2015/useMergeRef.js
var Ji = typeof window < "u" ? d.useLayoutEffect : d.useEffect, Yi = /* @__PURE__ */ new WeakMap();
function Xi(e, t) {
	var n = qi(t || null, function(t) {
		return e.forEach(function(e) {
			return Ki(e, t);
		});
	});
	return Ji(function() {
		var t = Yi.get(n);
		if (t) {
			var r = new Set(t), i = new Set(e), a = n.current;
			r.forEach(function(e) {
				i.has(e) || Ki(e, null);
			}), i.forEach(function(e) {
				r.has(e) || Ki(e, a);
			});
		}
		Yi.set(n, e);
	}, [e]), n;
}
// ../../../node_modules/use-sidecar/dist/es2015/medium.js
Vi();
function Zi(e) {
	return e;
}
function Qi(e, t) {
	t === void 0 && (t = Zi);
	var n = [], r = !1;
	return {
		read: function() {
			if (r) throw Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
			return n.length ? n[n.length - 1] : e;
		},
		useMedium: function(e) {
			var i = t(e, r);
			return n.push(i), function() {
				n = n.filter(function(e) {
					return e !== i;
				});
			};
		},
		assignSyncMedium: function(e) {
			for (r = !0; n.length;) {
				var t = n;
				n = [], t.forEach(e);
			}
			n = {
				push: function(t) {
					return e(t);
				},
				filter: function() {
					return n;
				}
			};
		},
		assignMedium: function(e) {
			r = !0;
			var t = [];
			if (n.length) {
				var i = n;
				n = [], i.forEach(e), t = n;
			}
			var a = function() {
				var n = t;
				t = [], n.forEach(e);
			}, o = function() {
				return Promise.resolve().then(a);
			};
			o(), n = {
				push: function(e) {
					t.push(e), o();
				},
				filter: function(e) {
					return t = t.filter(e), n;
				}
			};
		}
	};
}
function $i(e) {
	e === void 0 && (e = {});
	var t = Qi(null);
	return t.options = Y({
		async: !0,
		ssr: !1
	}, e), t;
}
// ../../../node_modules/use-sidecar/dist/es2015/exports.js
Vi();
var ea = function(e) {
	var t = e.sideCar, n = zi(e, ["sideCar"]);
	if (!t) throw Error("Sidecar: please provide `sideCar` property to import the right car");
	var r = t.read();
	if (!r) throw Error("Sidecar medium not found");
	return d.createElement(r, Y({}, n));
};
ea.isSideCarExport = !0;
function ta(e, t) {
	return e.useMedium(t), ea;
}
// ../../../node_modules/react-remove-scroll/dist/es2015/medium.js
var na = $i();
// ../../../node_modules/react-remove-scroll/dist/es2015/UI.js
Vi();
var ra = function() {}, ia = d.forwardRef(function(e, t) {
	var n = d.useRef(null), r = d.useState({
		onScrollCapture: ra,
		onWheelCapture: ra,
		onTouchMoveCapture: ra
	}), i = r[0], a = r[1], o = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, f = e.shards, p = e.sideCar, m = e.noRelative, h = e.noIsolation, g = e.inert, _ = e.allowPinchZoom, v = e.as, y = v === void 0 ? "div" : v, b = e.gapMode, x = zi(e, [
		"forwardProps",
		"children",
		"className",
		"removeScrollBar",
		"enabled",
		"shards",
		"sideCar",
		"noRelative",
		"noIsolation",
		"inert",
		"allowPinchZoom",
		"as",
		"gapMode"
	]), S = p, C = Xi([n, t]), w = Y(Y({}, x), i);
	return d.createElement(d.Fragment, null, u && d.createElement(S, {
		sideCar: na,
		removeScrollBar: l,
		shards: f,
		noRelative: m,
		noIsolation: h,
		inert: g,
		setCallbacks: a,
		allowPinchZoom: !!_,
		lockRef: n,
		gapMode: b
	}), o ? d.cloneElement(d.Children.only(s), Y(Y({}, w), { ref: C })) : d.createElement(y, Y({}, w, {
		className: c,
		ref: C
	}), s));
});
ia.defaultProps = {
	enabled: !0,
	removeScrollBar: !0,
	inert: !1
}, ia.classNames = {
	fullWidth: Ui,
	zeroRight: Hi
};
// ../../../node_modules/get-nonce/dist/es2015/index.js
var aa = function() {
	if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
};
// ../../../node_modules/react-style-singleton/dist/es2015/singleton.js
function oa() {
	if (!document) return null;
	var e = document.createElement("style");
	e.type = "text/css";
	var t = aa();
	return t && e.setAttribute("nonce", t), e;
}
function sa(e, t) {
	e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function ca(e) {
	(document.head || document.getElementsByTagName("head")[0]).appendChild(e);
}
var la = function() {
	var e = 0, t = null;
	return {
		add: function(n) {
			e == 0 && (t = oa()) && (sa(t, n), ca(t)), e++;
		},
		remove: function() {
			e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
		}
	};
}, ua = function() {
	var e = la();
	return function(t, n) {
		d.useEffect(function() {
			return e.add(t), function() {
				e.remove();
			};
		}, [t && n]);
	};
}, da = function() {
	var e = ua();
	return function(t) {
		var n = t.styles, r = t.dynamic;
		return e(n, r), null;
	};
}, fa = {
	left: 0,
	top: 0,
	right: 0,
	gap: 0
}, pa = function(e) {
	return parseInt(e || "", 10) || 0;
}, ma = function(e) {
	var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
	return [
		pa(n),
		pa(r),
		pa(i)
	];
}, ha = function(e) {
	if (e === void 0 && (e = "margin"), typeof window > "u") return fa;
	var t = ma(e), n = document.documentElement.clientWidth, r = window.innerWidth;
	return {
		left: t[0],
		top: t[1],
		right: t[2],
		gap: Math.max(0, r - n + t[2] - t[0])
	};
}, ga = da(), _a = "data-scroll-locked", va = function(e, t, n, r) {
	var i = e.left, a = e.top, o = e.right, s = e.gap;
	return n === void 0 && (n = "margin"), `
  .${Wi} {
   overflow: hidden ${r};
   padding-right: ${s}px ${r};
  }
  body[${_a}] {
    overflow: hidden ${r};
    overscroll-behavior: contain;
    ${[
		t && `position: relative ${r};`,
		n === "margin" && `
    padding-left: ${i}px;
    padding-top: ${a}px;
    padding-right: ${o}px;
    margin-left:0;
    margin-top:0;
    margin-right: ${s}px ${r};
    `,
		n === "padding" && `padding-right: ${s}px ${r};`
	].filter(Boolean).join("")}
  }
  
  .${Hi} {
    right: ${s}px ${r};
  }
  
  .${Ui} {
    margin-right: ${s}px ${r};
  }
  
  .${Hi} .${Hi} {
    right: 0 ${r};
  }
  
  .${Ui} .${Ui} {
    margin-right: 0 ${r};
  }
  
  body[${_a}] {
    ${Gi}: ${s}px;
  }
`;
}, ya = function() {
	var e = parseInt(document.body.getAttribute("data-scroll-locked") || "0", 10);
	return isFinite(e) ? e : 0;
}, ba = function() {
	d.useEffect(function() {
		return document.body.setAttribute(_a, (ya() + 1).toString()), function() {
			var e = ya() - 1;
			e <= 0 ? document.body.removeAttribute(_a) : document.body.setAttribute(_a, e.toString());
		};
	}, []);
}, xa = function(e) {
	var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
	ba();
	var a = d.useMemo(function() {
		return ha(i);
	}, [i]);
	return d.createElement(ga, { styles: va(a, !t, i, n ? "" : "!important") });
}, Sa = !1;
if (typeof window < "u") try {
	var Ca = Object.defineProperty({}, "passive", { get: function() {
		return Sa = !0, !0;
	} });
	window.addEventListener("test", Ca, Ca), window.removeEventListener("test", Ca, Ca);
} catch {
	Sa = !1;
}
var wa = Sa ? { passive: !1 } : !1, Ta = function(e) {
	return e.tagName === "TEXTAREA";
}, Ea = function(e, t) {
	if (!(e instanceof Element)) return !1;
	var n = window.getComputedStyle(e);
	return n[t] !== "hidden" && !(n.overflowY === n.overflowX && !Ta(e) && n[t] === "visible");
}, Da = function(e) {
	return Ea(e, "overflowY");
}, Oa = function(e) {
	return Ea(e, "overflowX");
}, ka = function(e, t) {
	var n = t.ownerDocument, r = t;
	do {
		if (typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host), Ma(e, r)) {
			var i = Na(e, r);
			if (i[1] > i[2]) return !0;
		}
		r = r.parentNode;
	} while (r && r !== n.body);
	return !1;
}, Aa = function(e) {
	return [
		e.scrollTop,
		e.scrollHeight,
		e.clientHeight
	];
}, ja = function(e) {
	return [
		e.scrollLeft,
		e.scrollWidth,
		e.clientWidth
	];
}, Ma = function(e, t) {
	return e === "v" ? Da(t) : Oa(t);
}, Na = function(e, t) {
	return e === "v" ? Aa(t) : ja(t);
}, Pa = function(e, t) {
	return e === "h" && t === "rtl" ? -1 : 1;
}, Fa = function(e, t, n, r, i) {
	var a = Pa(e, window.getComputedStyle(t).direction), o = a * r, s = n.target, c = t.contains(s), l = !1, u = o > 0, d = 0, f = 0;
	do {
		if (!s) break;
		var p = Na(e, s), m = p[0], h = p[1] - p[2] - a * m;
		(m || h) && Ma(e, s) && (d += h, f += m);
		var g = s.parentNode;
		s = g && g.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? g.host : g;
	} while (!c && s !== document.body || c && (t.contains(s) || t === s));
	return (u && (i && Math.abs(d) < 1 || !i && o > d) || !u && (i && Math.abs(f) < 1 || !i && -o > f)) && (l = !0), l;
};
// ../../../node_modules/react-remove-scroll/dist/es2015/SideEffect.js
Vi();
var Ia = function(e) {
	return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, La = function(e) {
	return [e.deltaX, e.deltaY];
}, Ra = function(e) {
	return e && "current" in e ? e.current : e;
}, za = function(e, t) {
	return e[0] === t[0] && e[1] === t[1];
}, Ba = function(e) {
	return `
  .block-interactivity-${e} {pointer-events: none;}
  .allow-interactivity-${e} {pointer-events: all;}
`;
}, Va = 0, Ha = [];
function Ua(e) {
	var t = d.useRef([]), n = d.useRef([0, 0]), r = d.useRef(), i = d.useState(Va++)[0], a = d.useState(da)[0], o = d.useRef(e);
	d.useEffect(function() {
		o.current = e;
	}, [e]), d.useEffect(function() {
		if (e.inert) {
			document.body.classList.add(`block-interactivity-${i}`);
			var t = Bi([e.lockRef.current], (e.shards || []).map(Ra), !0).filter(Boolean);
			return t.forEach(function(e) {
				return e.classList.add(`allow-interactivity-${i}`);
			}), function() {
				document.body.classList.remove(`block-interactivity-${i}`), t.forEach(function(e) {
					return e.classList.remove(`allow-interactivity-${i}`);
				});
			};
		}
	}, [
		e.inert,
		e.lockRef.current,
		e.shards
	]);
	var s = d.useCallback(function(e, t) {
		if ("touches" in e && e.touches.length === 2 || e.type === "wheel" && e.ctrlKey) return !o.current.allowPinchZoom;
		var i = Ia(e), a = n.current, s = "deltaX" in e ? e.deltaX : a[0] - i[0], c = "deltaY" in e ? e.deltaY : a[1] - i[1], l, u = e.target, d = Math.abs(s) > Math.abs(c) ? "h" : "v";
		if ("touches" in e && d === "h" && u.type === "range") return !1;
		var f = window.getSelection(), p = f && f.anchorNode;
		if (p && (p === u || p.contains(u))) return !1;
		var m = ka(d, u);
		if (!m) return !0;
		if (m ? l = d : (l = d === "v" ? "h" : "v", m = ka(d, u)), !m) return !1;
		if (!r.current && "changedTouches" in e && (s || c) && (r.current = l), !l) return !0;
		var h = r.current || l;
		return Fa(h, t, e, h === "h" ? s : c, !0);
	}, []), c = d.useCallback(function(e) {
		var n = e;
		if (Ha.length && Ha[Ha.length - 1] === a) {
			var r = "deltaY" in n ? La(n) : Ia(n), i = t.current.filter(function(e) {
				return e.name === n.type && (e.target === n.target || n.target === e.shadowParent) && za(e.delta, r);
			})[0];
			if (i && i.should) n.cancelable && n.preventDefault();
			else if (!i) {
				var c = (o.current.shards || []).map(Ra).filter(Boolean).filter(function(e) {
					return e.contains(n.target);
				});
				(c.length > 0 ? s(n, c[0]) : !o.current.noIsolation) && n.cancelable && n.preventDefault();
			}
		}
	}, []), l = d.useCallback(function(e, n, r, i) {
		var a = {
			name: e,
			delta: n,
			target: r,
			should: i,
			shadowParent: Wa(r)
		};
		t.current.push(a), setTimeout(function() {
			t.current = t.current.filter(function(e) {
				return e !== a;
			});
		}, 1);
	}, []), u = d.useCallback(function(e) {
		n.current = Ia(e), r.current = void 0;
	}, []), f = d.useCallback(function(t) {
		l(t.type, La(t), t.target, s(t, e.lockRef.current));
	}, []), p = d.useCallback(function(t) {
		l(t.type, Ia(t), t.target, s(t, e.lockRef.current));
	}, []);
	d.useEffect(function() {
		return Ha.push(a), e.setCallbacks({
			onScrollCapture: f,
			onWheelCapture: f,
			onTouchMoveCapture: p
		}), document.addEventListener("wheel", c, wa), document.addEventListener("touchmove", c, wa), document.addEventListener("touchstart", u, wa), function() {
			Ha = Ha.filter(function(e) {
				return e !== a;
			}), document.removeEventListener("wheel", c, wa), document.removeEventListener("touchmove", c, wa), document.removeEventListener("touchstart", u, wa);
		};
	}, []);
	var m = e.removeScrollBar, h = e.inert;
	return d.createElement(d.Fragment, null, h ? d.createElement(a, { styles: Ba(i) }) : null, m ? d.createElement(xa, {
		noRelative: e.noRelative,
		gapMode: e.gapMode
	}) : null);
}
function Wa(e) {
	for (var t = null; e !== null;) e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
	return t;
}
// ../../../node_modules/react-remove-scroll/dist/es2015/sidecar.js
var Ga = ta(na, Ua);
// ../../../node_modules/react-remove-scroll/dist/es2015/Combination.js
Vi();
var Ka = d.forwardRef(function(e, t) {
	return d.createElement(ia, Y({}, e, {
		ref: t,
		sideCar: Ga
	}));
});
Ka.classNames = ia.classNames;
// ../../../node_modules/@radix-ui/react-popover/dist/index.mjs
var qa = Object.defineProperty, Ja = (e, t) => qa(e, "name", {
	value: t,
	configurable: !0
}), Ya = "Popover", [Xa, Za] = /* @__PURE__ */ be(Ya, [Wr]), Qa = Wr(), [$a, eo] = Xa(Ya), to = /* @__PURE__ */ Ja((e) => {
	let { __scopePopover: t, children: n, open: r, defaultOpen: i, onOpenChange: a, modal: o = !1 } = e, s = Qa(t), c = d.useRef(null), [l, u] = d.useState(!1), [f, p] = Ti({
		prop: r,
		defaultProp: i ?? !1,
		onChange: a,
		caller: Ya
	});
	return /* @__PURE__ */ b(ri, {
		...s,
		children: /* @__PURE__ */ b($a, {
			scope: t,
			contentId: Dt(),
			triggerRef: c,
			open: f,
			onOpenChange: p,
			onOpenToggle: d.useCallback(() => p((e) => !e), [p]),
			hasCustomAnchor: l,
			onCustomAnchorAdd: d.useCallback(() => u(!0), []),
			onCustomAnchorRemove: d.useCallback(() => u(!1), []),
			modal: o,
			children: n
		})
	});
}, "Popover"), no = "PopoverAnchor", ro = /* @__PURE__ */ d.forwardRef(/* @__PURE__ */ Ja(function(e, t) {
	let { __scopePopover: n, ...r } = e, i = eo(no, n), a = Qa(n), { onCustomAnchorAdd: o, onCustomAnchorRemove: s } = i;
	return d.useEffect(() => (o(), () => s()), [o, s]), /* @__PURE__ */ b(ii, {
		...a,
		...r,
		ref: t
	});
}, "PopoverAnchor")), io = "PopoverTrigger", ao = /* @__PURE__ */ d.forwardRef(/* @__PURE__ */ Ja(function(e, t) {
	let { __scopePopover: n, ...r } = e, i = eo(io, n), a = Qa(n), o = _e(t, i.triggerRef), s = /* @__PURE__ */ b(V.button, {
		type: "button",
		"aria-haspopup": "dialog",
		"aria-expanded": i.open,
		"aria-controls": i.open ? i.contentId : void 0,
		"data-state": _o(i.open),
		...r,
		ref: o,
		onClick: P(e.onClick, i.onOpenToggle)
	});
	return i.hasCustomAnchor ? s : /* @__PURE__ */ b(ii, {
		asChild: !0,
		...a,
		children: s
	});
}, "PopoverTrigger")), oo = "PopoverPortal", [so, co] = Xa(oo, { forceMount: void 0 }), lo = /* @__PURE__ */ Ja((e) => {
	let { __scopePopover: t, forceMount: n, children: r, container: i } = e, a = eo(oo, t);
	return /* @__PURE__ */ b(so, {
		scope: t,
		forceMount: n,
		children: /* @__PURE__ */ b(di, {
			present: n || a.open,
			children: /* @__PURE__ */ b(si, {
				asChild: !0,
				container: i,
				children: r
			})
		})
	});
}, "PopoverPortal"), uo = "PopoverContent", fo = /* @__PURE__ */ d.forwardRef(/* @__PURE__ */ Ja(function(e, t) {
	let n = co(uo, e.__scopePopover), { forceMount: r = n.forceMount, ...i } = e, a = eo(uo, e.__scopePopover);
	return /* @__PURE__ */ b(di, {
		present: r || a.open,
		children: a.modal ? /* @__PURE__ */ b(mo, {
			...i,
			ref: t
		}) : /* @__PURE__ */ b(ho, {
			...i,
			ref: t
		})
	});
}, "PopoverContent")), po = /* @__PURE__ */ Ce("PopoverContent.RemoveScroll"), mo = /* @__PURE__ */ d.forwardRef(/* @__PURE__ */ Ja(function(e, t) {
	let n = eo(uo, e.__scopePopover), r = d.useRef(null), i = _e(t, r), a = d.useRef(!1);
	return d.useEffect(() => {
		let e = r.current;
		if (e) return Ri(e);
	}, []), /* @__PURE__ */ b(Ka, {
		as: po,
		allowPinchZoom: !0,
		children: /* @__PURE__ */ b(go, {
			...e,
			ref: i,
			trapFocus: n.open,
			disableOutsidePointerEvents: !0,
			onCloseAutoFocus: P(e.onCloseAutoFocus, (e) => {
				e.preventDefault(), a.current || n.triggerRef.current?.focus();
			}),
			onPointerDownOutside: P(e.onPointerDownOutside, (e) => {
				let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0, r = t.button === 2 || n;
				a.current = r;
			}, { checkForDefaultPrevented: !1 }),
			onFocusOutside: P(e.onFocusOutside, (e) => e.preventDefault(), { checkForDefaultPrevented: !1 })
		})
	});
}, "PopoverContentModal")), ho = /* @__PURE__ */ d.forwardRef(/* @__PURE__ */ Ja(function(e, t) {
	let n = eo(uo, e.__scopePopover), r = d.useRef(!1), i = d.useRef(!1);
	return /* @__PURE__ */ b(go, {
		...e,
		ref: t,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		onCloseAutoFocus: (t) => {
			e.onCloseAutoFocus?.(t), t.defaultPrevented || (r.current || n.triggerRef.current?.focus(), t.preventDefault()), r.current = !1, i.current = !1;
		},
		onInteractOutside: (t) => {
			e.onInteractOutside?.(t), t.defaultPrevented || (r.current = !0, t.detail.originalEvent.type === "pointerdown" && (i.current = !0));
			let a = t.target;
			n.triggerRef.current?.contains(a) && t.preventDefault(), t.detail.originalEvent.type === "focusin" && i.current && t.preventDefault();
		}
	});
}, "PopoverContentNonModal")), go = /* @__PURE__ */ d.forwardRef(/* @__PURE__ */ Ja(function(e, t) {
	let { __scopePopover: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, disableOutsidePointerEvents: o, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: l, onInteractOutside: u, ...d } = e, f = eo(uo, n), p = Qa(n);
	return it(), /* @__PURE__ */ b(ut, {
		asChild: !0,
		loop: !0,
		trapped: r,
		onMountAutoFocus: i,
		onUnmountAutoFocus: a,
		children: /* @__PURE__ */ b(Ke, {
			asChild: !0,
			disableOutsidePointerEvents: o,
			onInteractOutside: u,
			onEscapeKeyDown: s,
			onPointerDownOutside: c,
			onFocusOutside: l,
			onDismiss: () => f.onOpenChange(!1),
			deferPointerDownOutside: !0,
			children: /* @__PURE__ */ b(ai, {
				"data-state": _o(f.open),
				role: "dialog",
				id: f.contentId,
				...p,
				...d,
				ref: t,
				style: {
					...d.style,
					"--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
					"--radix-popover-content-available-width": "var(--radix-popper-available-width)",
					"--radix-popover-content-available-height": "var(--radix-popper-available-height)",
					"--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
					"--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
				}
			})
		})
	});
}, "PopoverContentImpl"));
function _o(e) {
	return e ? "open" : "closed";
}
Ja(_o, "getState");
var vo = to, yo = ro, bo = ao, xo = lo, So = fo;
// ../../../node_modules/fuse.js/dist/fuse.esm.js
function Co(e) {
	return Array.isArray ? Array.isArray(e) : Mo(e) === "[object Array]";
}
function wo(e) {
	if (typeof e == "string") return e;
	let t = e + "";
	return t == "0" && 1 / e == -Infinity ? "-0" : t;
}
function To(e) {
	return e == null ? "" : wo(e);
}
function Eo(e) {
	return typeof e == "string";
}
function Do(e) {
	return typeof e == "number";
}
function Oo(e) {
	return e === !0 || e === !1 || Ao(e) && Mo(e) == "[object Boolean]";
}
function ko(e) {
	return typeof e == "object";
}
function Ao(e) {
	return ko(e) && e !== null;
}
function X(e) {
	return e != null;
}
function jo(e) {
	return !e.trim().length;
}
function Mo(e) {
	return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
}
var No = "Incorrect 'index' type", Po = (e) => `Invalid value for key ${e}`, Fo = (e) => `Pattern length exceeds max of ${e}.`, Io = (e) => `Missing ${e} property in key`, Lo = (e) => `Property 'weight' in key '${e}' must be a positive integer`, Ro = Object.prototype.hasOwnProperty, zo = class {
	constructor(e) {
		this._keys = [], this._keyMap = {};
		let t = 0;
		e.forEach((e) => {
			let n = Bo(e);
			t += n.weight, this._keys.push(n), this._keyMap[n.id] = n, t += n.weight;
		}), this._keys.forEach((e) => {
			e.weight /= t;
		});
	}
	get(e) {
		return this._keyMap[e];
	}
	keys() {
		return this._keys;
	}
	toJSON() {
		return JSON.stringify(this._keys);
	}
};
function Bo(e) {
	let t = null, n = null, r = null, i = 1, a = null;
	if (Eo(e) || Co(e)) r = e, t = Vo(e), n = Ho(e);
	else {
		if (!Ro.call(e, "name")) throw Error(Io("name"));
		let o = e.name;
		if (r = o, Ro.call(e, "weight") && (i = e.weight, i <= 0)) throw Error(Lo(o));
		t = Vo(o), n = Ho(o), a = e.getFn;
	}
	return {
		path: t,
		id: n,
		weight: i,
		src: r,
		getFn: a
	};
}
function Vo(e) {
	return Co(e) ? e : e.split(".");
}
function Ho(e) {
	return Co(e) ? e.join(".") : e;
}
function Uo(e, t) {
	let n = [], r = !1, i = (e, t, a) => {
		if (X(e)) {
			if (!t[a]) n.push(e);
			else {
				let o = e[t[a]];
				if (!X(o)) return;
				if (a === t.length - 1 && (Eo(o) || Do(o) || Oo(o))) n.push(To(o));
				else if (Co(o)) {
					r = !0;
					for (let e = 0, n = o.length; e < n; e += 1) i(o[e], t, a + 1);
				} else t.length && i(o, t, a + 1);
			}
		}
	};
	return i(e, Eo(t) ? t.split(".") : t, 0), r ? n : n[0];
}
var Wo = {
	includeMatches: !1,
	findAllMatches: !1,
	minMatchCharLength: 1
}, Go = {
	isCaseSensitive: !1,
	includeScore: !1,
	keys: [],
	shouldSort: !0,
	sortFn: (e, t) => e.score === t.score ? e.idx < t.idx ? -1 : 1 : e.score < t.score ? -1 : 1
}, Ko = {
	location: 0,
	threshold: .6,
	distance: 100
}, qo = {
	useExtendedSearch: !1,
	getFn: Uo,
	ignoreLocation: !1,
	ignoreFieldNorm: !1,
	fieldNormWeight: 1
}, Z = {
	...Go,
	...Wo,
	...Ko,
	...qo
}, Jo = /[^ ]+/g;
function Yo(e = 1, t = 3) {
	let n = /* @__PURE__ */ new Map(), r = 10 ** t;
	return {
		get(t) {
			let i = t.match(Jo).length;
			if (n.has(i)) return n.get(i);
			let a = 1 / i ** (.5 * e), o = parseFloat(Math.round(a * r) / r);
			return n.set(i, o), o;
		},
		clear() {
			n.clear();
		}
	};
}
var Xo = class {
	constructor({ getFn: e = Z.getFn, fieldNormWeight: t = Z.fieldNormWeight } = {}) {
		this.norm = Yo(t, 3), this.getFn = e, this.isCreated = !1, this.setIndexRecords();
	}
	setSources(e = []) {
		this.docs = e;
	}
	setIndexRecords(e = []) {
		this.records = e;
	}
	setKeys(e = []) {
		this.keys = e, this._keysMap = {}, e.forEach((e, t) => {
			this._keysMap[e.id] = t;
		});
	}
	create() {
		!this.isCreated && this.docs.length && (this.isCreated = !0, Eo(this.docs[0]) ? this.docs.forEach((e, t) => {
			this._addString(e, t);
		}) : this.docs.forEach((e, t) => {
			this._addObject(e, t);
		}), this.norm.clear());
	}
	add(e) {
		let t = this.size();
		Eo(e) ? this._addString(e, t) : this._addObject(e, t);
	}
	removeAt(e) {
		this.records.splice(e, 1);
		for (let t = e, n = this.size(); t < n; t += 1) --this.records[t].i;
	}
	getValueForItemAtKeyId(e, t) {
		return e[this._keysMap[t]];
	}
	size() {
		return this.records.length;
	}
	_addString(e, t) {
		if (!X(e) || jo(e)) return;
		let n = {
			v: e,
			i: t,
			n: this.norm.get(e)
		};
		this.records.push(n);
	}
	_addObject(e, t) {
		let n = {
			i: t,
			$: {}
		};
		this.keys.forEach((t, r) => {
			let i = t.getFn ? t.getFn(e) : this.getFn(e, t.path);
			if (X(i)) {
				if (Co(i)) {
					let e = [], t = [{
						nestedArrIndex: -1,
						value: i
					}];
					for (; t.length;) {
						let { nestedArrIndex: n, value: r } = t.pop();
						if (X(r)) {
							if (Eo(r) && !jo(r)) {
								let t = {
									v: r,
									i: n,
									n: this.norm.get(r)
								};
								e.push(t);
							} else Co(r) && r.forEach((e, n) => {
								t.push({
									nestedArrIndex: n,
									value: e
								});
							});
						}
					}
					n.$[r] = e;
				} else if (Eo(i) && !jo(i)) {
					let e = {
						v: i,
						n: this.norm.get(i)
					};
					n.$[r] = e;
				}
			}
		}), this.records.push(n);
	}
	toJSON() {
		return {
			keys: this.keys,
			records: this.records
		};
	}
};
function Zo(e, t, { getFn: n = Z.getFn, fieldNormWeight: r = Z.fieldNormWeight } = {}) {
	let i = new Xo({
		getFn: n,
		fieldNormWeight: r
	});
	return i.setKeys(e.map(Bo)), i.setSources(t), i.create(), i;
}
function Qo(e, { getFn: t = Z.getFn, fieldNormWeight: n = Z.fieldNormWeight } = {}) {
	let { keys: r, records: i } = e, a = new Xo({
		getFn: t,
		fieldNormWeight: n
	});
	return a.setKeys(r), a.setIndexRecords(i), a;
}
function $o(e, { errors: t = 0, currentLocation: n = 0, expectedLocation: r = 0, distance: i = Z.distance, ignoreLocation: a = Z.ignoreLocation } = {}) {
	let o = t / e.length;
	if (a) return o;
	let s = Math.abs(r - n);
	return i ? o + s / i : s ? 1 : o;
}
function es(e = [], t = Z.minMatchCharLength) {
	let n = [], r = -1, i = -1, a = 0;
	for (let o = e.length; a < o; a += 1) {
		let o = e[a];
		o && r === -1 ? r = a : !o && r !== -1 && (i = a - 1, i - r + 1 >= t && n.push([r, i]), r = -1);
	}
	return e[a - 1] && a - r >= t && n.push([r, a - 1]), n;
}
var ts = 32;
function ns(e, t, n, { location: r = Z.location, distance: i = Z.distance, threshold: a = Z.threshold, findAllMatches: o = Z.findAllMatches, minMatchCharLength: s = Z.minMatchCharLength, includeMatches: c = Z.includeMatches, ignoreLocation: l = Z.ignoreLocation } = {}) {
	if (t.length > ts) throw Error(Fo(ts));
	let u = t.length, d = e.length, f = Math.max(0, Math.min(r, d)), p = a, m = f, h = s > 1 || c, g = h ? Array(d) : [], _;
	for (; (_ = e.indexOf(t, m)) > -1;) {
		let e = $o(t, {
			currentLocation: _,
			expectedLocation: f,
			distance: i,
			ignoreLocation: l
		});
		if (p = Math.min(e, p), m = _ + u, h) {
			let e = 0;
			for (; e < u;) g[_ + e] = 1, e += 1;
		}
	}
	m = -1;
	let v = [], y = 1, b = u + d, x = 1 << u - 1;
	for (let r = 0; r < u; r += 1) {
		let a = 0, s = b;
		for (; a < s;) $o(t, {
			errors: r,
			currentLocation: f + s,
			expectedLocation: f,
			distance: i,
			ignoreLocation: l
		}) <= p ? a = s : b = s, s = Math.floor((b - a) / 2 + a);
		b = s;
		let c = Math.max(1, f - s + 1), _ = o ? d : Math.min(f + s, d) + u, S = Array(_ + 2);
		S[_ + 1] = (1 << r) - 1;
		for (let a = _; a >= c; --a) {
			let o = a - 1, s = n[e.charAt(o)];
			if (h && (g[o] = +!!s), S[a] = (S[a + 1] << 1 | 1) & s, r && (S[a] |= (v[a + 1] | v[a]) << 1 | 1 | v[a + 1]), S[a] & x && (y = $o(t, {
				errors: r,
				currentLocation: o,
				expectedLocation: f,
				distance: i,
				ignoreLocation: l
			}), y <= p)) {
				if (p = y, m = o, m <= f) break;
				c = Math.max(1, 2 * f - m);
			}
		}
		if ($o(t, {
			errors: r + 1,
			currentLocation: f,
			expectedLocation: f,
			distance: i,
			ignoreLocation: l
		}) > p) break;
		v = S;
	}
	let S = {
		isMatch: m >= 0,
		score: Math.max(.001, y)
	};
	if (h) {
		let e = es(g, s);
		e.length ? c && (S.indices = e) : S.isMatch = !1;
	}
	return S;
}
function rs(e) {
	let t = {};
	for (let n = 0, r = e.length; n < r; n += 1) {
		let i = e.charAt(n);
		t[i] = (t[i] || 0) | 1 << r - n - 1;
	}
	return t;
}
var is = class {
	constructor(e, { location: t = Z.location, threshold: n = Z.threshold, distance: r = Z.distance, includeMatches: i = Z.includeMatches, findAllMatches: a = Z.findAllMatches, minMatchCharLength: o = Z.minMatchCharLength, isCaseSensitive: s = Z.isCaseSensitive, ignoreLocation: c = Z.ignoreLocation } = {}) {
		if (this.options = {
			location: t,
			threshold: n,
			distance: r,
			includeMatches: i,
			findAllMatches: a,
			minMatchCharLength: o,
			isCaseSensitive: s,
			ignoreLocation: c
		}, this.pattern = s ? e : e.toLowerCase(), this.chunks = [], !this.pattern.length) return;
		let l = (e, t) => {
			this.chunks.push({
				pattern: e,
				alphabet: rs(e),
				startIndex: t
			});
		}, u = this.pattern.length;
		if (u > ts) {
			let e = 0, t = u % ts, n = u - t;
			for (; e < n;) l(this.pattern.substr(e, ts), e), e += ts;
			if (t) {
				let e = u - ts;
				l(this.pattern.substr(e), e);
			}
		} else l(this.pattern, 0);
	}
	searchIn(e) {
		let { isCaseSensitive: t, includeMatches: n } = this.options;
		if (t || (e = e.toLowerCase()), this.pattern === e) {
			let t = {
				isMatch: !0,
				score: 0
			};
			return n && (t.indices = [[0, e.length - 1]]), t;
		}
		let { location: r, distance: i, threshold: a, findAllMatches: o, minMatchCharLength: s, ignoreLocation: c } = this.options, l = [], u = 0, d = !1;
		this.chunks.forEach(({ pattern: t, alphabet: f, startIndex: p }) => {
			let { isMatch: m, score: h, indices: g } = ns(e, t, f, {
				location: r + p,
				distance: i,
				threshold: a,
				findAllMatches: o,
				minMatchCharLength: s,
				includeMatches: n,
				ignoreLocation: c
			});
			m && (d = !0), u += h, m && g && (l = [...l, ...g]);
		});
		let f = {
			isMatch: d,
			score: d ? u / this.chunks.length : 1
		};
		return d && n && (f.indices = l), f;
	}
}, as = class {
	constructor(e) {
		this.pattern = e;
	}
	static isMultiMatch(e) {
		return os(e, this.multiRegex);
	}
	static isSingleMatch(e) {
		return os(e, this.singleRegex);
	}
	search() {}
};
function os(e, t) {
	let n = e.match(t);
	return n ? n[1] : null;
}
var ss = class extends as {
	constructor(e) {
		super(e);
	}
	static get type() {
		return "exact";
	}
	static get multiRegex() {
		return /^="(.*)"$/;
	}
	static get singleRegex() {
		return /^=(.*)$/;
	}
	search(e) {
		let t = e === this.pattern;
		return {
			isMatch: t,
			score: +!t,
			indices: [0, this.pattern.length - 1]
		};
	}
}, cs = class extends as {
	constructor(e) {
		super(e);
	}
	static get type() {
		return "inverse-exact";
	}
	static get multiRegex() {
		return /^!"(.*)"$/;
	}
	static get singleRegex() {
		return /^!(.*)$/;
	}
	search(e) {
		let t = e.indexOf(this.pattern) === -1;
		return {
			isMatch: t,
			score: +!t,
			indices: [0, e.length - 1]
		};
	}
}, ls = class extends as {
	constructor(e) {
		super(e);
	}
	static get type() {
		return "prefix-exact";
	}
	static get multiRegex() {
		return /^\^"(.*)"$/;
	}
	static get singleRegex() {
		return /^\^(.*)$/;
	}
	search(e) {
		let t = e.startsWith(this.pattern);
		return {
			isMatch: t,
			score: +!t,
			indices: [0, this.pattern.length - 1]
		};
	}
}, us = class extends as {
	constructor(e) {
		super(e);
	}
	static get type() {
		return "inverse-prefix-exact";
	}
	static get multiRegex() {
		return /^!\^"(.*)"$/;
	}
	static get singleRegex() {
		return /^!\^(.*)$/;
	}
	search(e) {
		let t = !e.startsWith(this.pattern);
		return {
			isMatch: t,
			score: +!t,
			indices: [0, e.length - 1]
		};
	}
}, ds = class extends as {
	constructor(e) {
		super(e);
	}
	static get type() {
		return "suffix-exact";
	}
	static get multiRegex() {
		return /^"(.*)"\$$/;
	}
	static get singleRegex() {
		return /^(.*)\$$/;
	}
	search(e) {
		let t = e.endsWith(this.pattern);
		return {
			isMatch: t,
			score: +!t,
			indices: [e.length - this.pattern.length, e.length - 1]
		};
	}
}, fs = class extends as {
	constructor(e) {
		super(e);
	}
	static get type() {
		return "inverse-suffix-exact";
	}
	static get multiRegex() {
		return /^!"(.*)"\$$/;
	}
	static get singleRegex() {
		return /^!(.*)\$$/;
	}
	search(e) {
		let t = !e.endsWith(this.pattern);
		return {
			isMatch: t,
			score: +!t,
			indices: [0, e.length - 1]
		};
	}
}, ps = class extends as {
	constructor(e, { location: t = Z.location, threshold: n = Z.threshold, distance: r = Z.distance, includeMatches: i = Z.includeMatches, findAllMatches: a = Z.findAllMatches, minMatchCharLength: o = Z.minMatchCharLength, isCaseSensitive: s = Z.isCaseSensitive, ignoreLocation: c = Z.ignoreLocation } = {}) {
		super(e), this._bitapSearch = new is(e, {
			location: t,
			threshold: n,
			distance: r,
			includeMatches: i,
			findAllMatches: a,
			minMatchCharLength: o,
			isCaseSensitive: s,
			ignoreLocation: c
		});
	}
	static get type() {
		return "fuzzy";
	}
	static get multiRegex() {
		return /^"(.*)"$/;
	}
	static get singleRegex() {
		return /^(.*)$/;
	}
	search(e) {
		return this._bitapSearch.searchIn(e);
	}
}, ms = class extends as {
	constructor(e) {
		super(e);
	}
	static get type() {
		return "include";
	}
	static get multiRegex() {
		return /^'"(.*)"$/;
	}
	static get singleRegex() {
		return /^'(.*)$/;
	}
	search(e) {
		let t = 0, n, r = [], i = this.pattern.length;
		for (; (n = e.indexOf(this.pattern, t)) > -1;) t = n + i, r.push([n, t - 1]);
		let a = !!r.length;
		return {
			isMatch: a,
			score: +!a,
			indices: r
		};
	}
}, hs = [
	ss,
	ms,
	ls,
	us,
	fs,
	ds,
	cs,
	ps
], gs = hs.length, _s = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/, vs = "|";
function ys(e, t = {}) {
	return e.split(vs).map((e) => {
		let n = e.trim().split(_s).filter((e) => e && !!e.trim()), r = [];
		for (let e = 0, i = n.length; e < i; e += 1) {
			let i = n[e], a = !1, o = -1;
			for (; !a && ++o < gs;) {
				let e = hs[o], n = e.isMultiMatch(i);
				n && (r.push(new e(n, t)), a = !0);
			}
			if (!a) for (o = -1; ++o < gs;) {
				let e = hs[o], n = e.isSingleMatch(i);
				if (n) {
					r.push(new e(n, t));
					break;
				}
			}
		}
		return r;
	});
}
var bs = /* @__PURE__ */ new Set([ps.type, ms.type]), xs = class {
	constructor(e, { isCaseSensitive: t = Z.isCaseSensitive, includeMatches: n = Z.includeMatches, minMatchCharLength: r = Z.minMatchCharLength, ignoreLocation: i = Z.ignoreLocation, findAllMatches: a = Z.findAllMatches, location: o = Z.location, threshold: s = Z.threshold, distance: c = Z.distance } = {}) {
		this.query = null, this.options = {
			isCaseSensitive: t,
			includeMatches: n,
			minMatchCharLength: r,
			findAllMatches: a,
			ignoreLocation: i,
			location: o,
			threshold: s,
			distance: c
		}, this.pattern = t ? e : e.toLowerCase(), this.query = ys(this.pattern, this.options);
	}
	static condition(e, t) {
		return t.useExtendedSearch;
	}
	searchIn(e) {
		let t = this.query;
		if (!t) return {
			isMatch: !1,
			score: 1
		};
		let { includeMatches: n, isCaseSensitive: r } = this.options;
		e = r ? e : e.toLowerCase();
		let i = 0, a = [], o = 0;
		for (let r = 0, s = t.length; r < s; r += 1) {
			let s = t[r];
			a.length = 0, i = 0;
			for (let t = 0, r = s.length; t < r; t += 1) {
				let r = s[t], { isMatch: c, indices: l, score: u } = r.search(e);
				if (c) {
					if (i += 1, o += u, n) {
						let e = r.constructor.type;
						bs.has(e) ? a = [...a, ...l] : a.push(l);
					}
				} else {
					o = 0, i = 0, a.length = 0;
					break;
				}
			}
			if (i) {
				let e = {
					isMatch: !0,
					score: o / i
				};
				return n && (e.indices = a), e;
			}
		}
		return {
			isMatch: !1,
			score: 1
		};
	}
}, Ss = [];
function Cs(...e) {
	Ss.push(...e);
}
function ws(e, t) {
	for (let n = 0, r = Ss.length; n < r; n += 1) {
		let r = Ss[n];
		if (r.condition(e, t)) return new r(e, t);
	}
	return new is(e, t);
}
var Ts = {
	AND: "$and",
	OR: "$or"
}, Es = {
	PATH: "$path",
	PATTERN: "$val"
}, Ds = (e) => !!(e[Ts.AND] || e[Ts.OR]), Os = (e) => !!e[Es.PATH], ks = (e) => !Co(e) && ko(e) && !Ds(e), As = (e) => ({ [Ts.AND]: Object.keys(e).map((t) => ({ [t]: e[t] })) });
function js(e, t, { auto: n = !0 } = {}) {
	let r = (e) => {
		let i = Object.keys(e), a = Os(e);
		if (!a && i.length > 1 && !Ds(e)) return r(As(e));
		if (ks(e)) {
			let r = a ? e[Es.PATH] : i[0], o = a ? e[Es.PATTERN] : e[r];
			if (!Eo(o)) throw Error(Po(r));
			let s = {
				keyId: Ho(r),
				pattern: o
			};
			return n && (s.searcher = ws(o, t)), s;
		}
		let o = {
			children: [],
			operator: i[0]
		};
		return i.forEach((t) => {
			let n = e[t];
			Co(n) && n.forEach((e) => {
				o.children.push(r(e));
			});
		}), o;
	};
	return Ds(e) || (e = As(e)), r(e);
}
function Ms(e, { ignoreFieldNorm: t = Z.ignoreFieldNorm }) {
	e.forEach((e) => {
		let n = 1;
		e.matches.forEach(({ key: e, norm: r, score: i }) => {
			let a = e ? e.weight : null;
			n *= (i === 0 && a ? 2 ** -52 : i) ** +((a || 1) * (t ? 1 : r));
		}), e.score = n;
	});
}
function Ns(e, t) {
	let n = e.matches;
	t.matches = [], X(n) && n.forEach((e) => {
		if (!X(e.indices) || !e.indices.length) return;
		let { indices: n, value: r } = e, i = {
			indices: n,
			value: r
		};
		e.key && (i.key = e.key.src), e.idx > -1 && (i.refIndex = e.idx), t.matches.push(i);
	});
}
function Ps(e, t) {
	t.score = e.score;
}
function Fs(e, t, { includeMatches: n = Z.includeMatches, includeScore: r = Z.includeScore } = {}) {
	let i = [];
	return n && i.push(Ns), r && i.push(Ps), e.map((e) => {
		let { idx: n } = e, r = {
			item: t[n],
			refIndex: n
		};
		return i.length && i.forEach((t) => {
			t(e, r);
		}), r;
	});
}
var Is = class {
	constructor(e, t = {}, n) {
		this.options = {
			...Z,
			...t
		}, this.options.useExtendedSearch, this._keyStore = new zo(this.options.keys), this.setCollection(e, n);
	}
	setCollection(e, t) {
		if (this._docs = e, t && !(t instanceof Xo)) throw Error(No);
		this._myIndex = t || Zo(this.options.keys, this._docs, {
			getFn: this.options.getFn,
			fieldNormWeight: this.options.fieldNormWeight
		});
	}
	add(e) {
		X(e) && (this._docs.push(e), this._myIndex.add(e));
	}
	remove(e = () => !1) {
		let t = [];
		for (let n = 0, r = this._docs.length; n < r; n += 1) {
			let i = this._docs[n];
			e(i, n) && (this.removeAt(n), --n, --r, t.push(i));
		}
		return t;
	}
	removeAt(e) {
		this._docs.splice(e, 1), this._myIndex.removeAt(e);
	}
	getIndex() {
		return this._myIndex;
	}
	search(e, { limit: t = -1 } = {}) {
		let { includeMatches: n, includeScore: r, shouldSort: i, sortFn: a, ignoreFieldNorm: o } = this.options, s = Eo(e) ? Eo(this._docs[0]) ? this._searchStringList(e) : this._searchObjectList(e) : this._searchLogical(e);
		return Ms(s, { ignoreFieldNorm: o }), i && s.sort(a), Do(t) && t > -1 && (s = s.slice(0, t)), Fs(s, this._docs, {
			includeMatches: n,
			includeScore: r
		});
	}
	_searchStringList(e) {
		let t = ws(e, this.options), { records: n } = this._myIndex, r = [];
		return n.forEach(({ v: e, i: n, n: i }) => {
			if (!X(e)) return;
			let { isMatch: a, score: o, indices: s } = t.searchIn(e);
			a && r.push({
				item: e,
				idx: n,
				matches: [{
					score: o,
					value: e,
					norm: i,
					indices: s
				}]
			});
		}), r;
	}
	_searchLogical(e) {
		let t = js(e, this.options), n = (e, t, r) => {
			if (!e.children) {
				let { keyId: n, searcher: i } = e, a = this._findMatches({
					key: this._keyStore.get(n),
					value: this._myIndex.getValueForItemAtKeyId(t, n),
					searcher: i
				});
				return a && a.length ? [{
					idx: r,
					item: t,
					matches: a
				}] : [];
			}
			let i = [];
			for (let a = 0, o = e.children.length; a < o; a += 1) {
				let o = e.children[a], s = n(o, t, r);
				if (s.length) i.push(...s);
				else if (e.operator === Ts.AND) return [];
			}
			return i;
		}, r = this._myIndex.records, i = {}, a = [];
		return r.forEach(({ $: e, i: r }) => {
			if (X(e)) {
				let o = n(t, e, r);
				o.length && (i[r] || (i[r] = {
					idx: r,
					item: e,
					matches: []
				}, a.push(i[r])), o.forEach(({ matches: e }) => {
					i[r].matches.push(...e);
				}));
			}
		}), a;
	}
	_searchObjectList(e) {
		let t = ws(e, this.options), { keys: n, records: r } = this._myIndex, i = [];
		return r.forEach(({ $: e, i: r }) => {
			if (!X(e)) return;
			let a = [];
			n.forEach((n, r) => {
				a.push(...this._findMatches({
					key: n,
					value: e[r],
					searcher: t
				}));
			}), a.length && i.push({
				idx: r,
				item: e,
				matches: a
			});
		}), i;
	}
	_findMatches({ key: e, value: t, searcher: n }) {
		if (!X(t)) return [];
		let r = [];
		if (Co(t)) t.forEach(({ v: t, i, n: a }) => {
			if (!X(t)) return;
			let { isMatch: o, score: s, indices: c } = n.searchIn(t);
			o && r.push({
				score: s,
				key: e,
				value: t,
				idx: i,
				norm: a,
				indices: c
			});
		});
		else {
			let { v: i, n: a } = t, { isMatch: o, score: s, indices: c } = n.searchIn(i);
			o && r.push({
				score: s,
				key: e,
				value: i,
				norm: a,
				indices: c
			});
		}
		return r;
	}
};
Is.version = "6.6.2", Is.createIndex = Zo, Is.parseIndex = Qo, Is.config = Z, Is.parseQuery = js, Cs(xs);
// \0callable-external:lodash/groupBy
var Ls = T, Rs = E;
// ../../../node_modules/react-use/esm/useTimeoutFn.js
function zs(e, t) {
	t === void 0 && (t = 0);
	var n = _(!1), r = _(), i = _(e), a = p(function() {
		return n.current;
	}, []), o = p(function() {
		n.current = !1, r.current && clearTimeout(r.current), r.current = setTimeout(function() {
			n.current = !0, i.current();
		}, t);
	}, [t]), s = p(function() {
		n.current = null, r.current && clearTimeout(r.current);
	}, []);
	return m(function() {
		i.current = e;
	}, [e]), m(function() {
		return o(), s;
	}, [t]), [
		a,
		s,
		o
	];
}
// ../../../node_modules/react-use/esm/useDebounce.js
function Bs(e, t, n) {
	t === void 0 && (t = 0), n === void 0 && (n = []);
	var r = zs(e, t), i = r[0], a = r[1], o = r[2];
	return m(o, n), [i, a];
}
var Q = {
	root: "_root_1p912_54",
	disabled: "_disabled_1p912_57",
	toolbar: "_toolbar_1p912_57",
	addButton: "_addButton_1p912_58",
	editorWrapper: "_editorWrapper_1p912_63",
	textarea: "_textarea_1p912_78",
	editor: "_editor_1p912_63",
	input: "_input_1p912_90",
	token: "_token_1p912_99",
	toolbarTop: "_toolbarTop_1p912_143",
	toolbarBottom: "_toolbarBottom_1p912_151",
	toolbarButton: "_toolbarButton_1p912_159",
	toolbarButtonActive: "_toolbarButtonActive_1p912_175",
	toolbarInsertVariable: "_toolbarInsertVariable_1p912_180",
	list: "_list_1p912_193",
	heading: "_heading_1p912_201",
	listItemContent: "_listItemContent_1p912_219",
	emojiRow: "_emojiRow_1p912_223",
	emojiGlyph: "_emojiGlyph_1p912_229",
	emojiPickerPortal: "_emojiPickerPortal_1p912_234",
	selected: "_selected_1p912_259",
	unresolvedToken: "_unresolvedToken_1p912_263",
	tokenEditIcon: "_tokenEditIcon_1p912_283",
	buttonPortal: "_buttonPortal_1p912_288",
	portal: "_portal_1p912_299",
	suggestion: "_suggestion_1p912_311",
	highlighted: "_highlighted_1p912_319",
	placeholder: "_placeholder_1p912_330",
	divider: "_divider_1p912_351",
	popoverTopButton: "_popoverTopButton_1p912_360",
	suggestionWithActions: "_suggestionWithActions_1p912_371",
	suggestionActions: "_suggestionActions_1p912_377",
	suggestionActionButton: "_suggestionActionButton_1p912_386"
}, Vs = (e, t) => {
	let { selection: n } = e;
	if (!n) return !1;
	let [r] = Array.from(D.nodes(e, {
		at: D.unhangRange(e, n),
		match: (e) => !D.isEditor(e) && O.isElement(e) && e.type === "heading" && e.level === t
	}));
	return !!r;
}, Hs = (e, t) => {
	let n = Vs(e, t), r = (e) => O.isElement(e) && (e.type === "paragraph" || e.type === "heading");
	D.withoutNormalizing(e, () => {
		n ? (N.setNodes(e, { type: "paragraph" }, {
			match: r,
			mode: "lowest"
		}), N.unsetNodes(e, "level", {
			match: (e) => O.isElement(e) && e.type === "paragraph",
			mode: "lowest"
		})) : N.setNodes(e, {
			type: "heading",
			level: t
		}, {
			match: r,
			mode: "lowest"
		});
	});
}, Us = ["bulleted-list", "numbered-list"], Ws = (e) => Us.includes(e), Gs = (e) => O.isElement(e) && Ws(e.type), Ks = (e) => O.isElement(e) && e.type === "list-item", qs = (e) => e === "bulleted-list" ? "numbered-list" : "bulleted-list", Js = (e, t) => {
	let { selection: n } = e;
	if (!n) return !1;
	let [r] = Array.from(D.nodes(e, {
		at: D.unhangRange(e, n),
		match: (e) => !D.isEditor(e) && O.isElement(e) && e.type === t
	}));
	return !!r;
}, Ys = (e) => {
	let { selection: t } = e;
	if (!t) return;
	let [n] = D.nodes(e, {
		at: t,
		match: (e) => Ks(e),
		mode: "lowest"
	});
	return n;
}, Xs = (e, t) => {
	let n = Js(e, t), r = Js(e, qs(t));
	D.withoutNormalizing(e, () => {
		n ? (N.setNodes(e, { type: "paragraph" }, {
			match: (e) => O.isElement(e) && e.type === "list-item-content",
			mode: "lowest"
		}), N.unwrapNodes(e, {
			match: Ks,
			split: !0
		}), N.unwrapNodes(e, {
			match: Gs,
			split: !0
		})) : r ? N.setNodes(e, { type: t }, {
			match: Gs,
			mode: "lowest"
		}) : (N.setNodes(e, { type: "list-item-content" }), N.wrapNodes(e, {
			type: "list-item",
			children: []
		}), N.wrapNodes(e, {
			type: t,
			children: []
		}));
	});
}, Zs = (e) => {
	let t = Ys(e);
	if (!t) return !1;
	let [, n] = t;
	return n[n.length - 1] !== 0 && (D.withoutNormalizing(e, () => {
		let t = A.parent(n), r = k.get(e, t).type, i = A.previous(n), a = k.get(e, i), o = a.children[a.children.length - 1];
		if (O.isElement(o) && Ws(o.type)) {
			let t = [...i, a.children.length - 1];
			N.moveNodes(e, {
				at: n,
				to: [...t, o.children.length]
			});
		} else {
			let t = [...i, a.children.length];
			N.insertNodes(e, {
				type: r,
				children: []
			}, { at: t }), N.moveNodes(e, {
				at: n,
				to: [...t, 0]
			});
		}
	}), !0);
}, Qs = (e) => {
	let t = Ys(e);
	if (!t) return !1;
	let [, n] = t, r = A.parent(n), i = A.parent(r);
	return !D.hasPath(e, i) || !Ks(k.get(e, i)) ? !1 : (D.withoutNormalizing(e, () => {
		let t = k.get(e, r), a = n[n.length - 1], o = t.children.length - 1 - a;
		if (o > 0) {
			let i = t.type, s = k.get(e, n), c = s.children[s.children.length - 1], l;
			O.isElement(c) && Ws(c.type) ? l = [...n, s.children.length - 1] : (l = [...n, s.children.length], N.insertNodes(e, {
				type: i,
				children: []
			}, { at: l }));
			for (let t = 0; t < o; t++) {
				let t = k.get(e, l);
				N.moveNodes(e, {
					at: [...r, a + 1],
					to: [...l, t.children.length]
				});
			}
		}
		N.moveNodes(e, {
			at: n,
			to: A.next(i)
		});
	}), !0);
}, $s = (e, t) => {
	let n = D.marks(e);
	return n ? n[t] === !0 : !1;
}, ec = (e, t) => {
	$s(e, t) ? D.removeMark(e, t) : D.addMark(e, t, !0);
}, tc = (e, t) => e.map((e) => {
	if (ic(e)) {
		let n = t.find(({ id: t }) => t === e.id) ?? t.find(({ token: t }) => t.text === e.tokenText);
		if (!n) {
			let t = e.tokenText.replace(/[{}]/g, "");
			return {
				type: "token",
				id: t,
				tokenText: t,
				children: [{ text: "" }]
			};
		}
		let { id: r, token: i } = n;
		return {
			...e,
			id: r,
			tokenText: i.text,
			className: i.className,
			tooltip: i.tooltip,
			showTokenEditIcon: i.showTokenEditIcon
		};
	}
	return O.isElement(e) ? {
		...e,
		children: tc(e.children, t)
	} : e;
}), nc = (e, t) => {
	let { isInline: n, isVoid: r, insertFragment: i } = e;
	return e.isInline = (e) => e.type === "token" || n(e), e.isVoid = (e) => e.type === "token" || r(e), e.insertFragment = (e) => {
		i(tc(e, t()));
	}, e;
}, rc = (e, t, n, r, i, a) => {
	let o = {
		type: "token",
		id: t,
		className: r,
		tooltip: i,
		showTokenEditIcon: a,
		tokenText: n,
		children: [{ text: "" }]
	};
	N.insertNodes(e, o);
	let s;
	for (let [, n] of D.nodes(e, {
		at: [],
		match: (n) => O.isElement(n) && e.isVoid(n) && n.id === t,
		voids: !0
	})) s = n;
	if (s) {
		let t = A.next(s);
		if (D.hasPath(e, t)) {
			let n = k.get(e, t);
			ee.isText(n) && (n.text[0] !== " " && e.apply({
				type: "insert_text",
				path: t,
				offset: 0,
				text: " "
			}), N.select(e, {
				path: t,
				offset: 1
			}));
		}
	}
}, ic = (e) => typeof e == "object" && !!e && "type" in e && e.type === "token" && "tokenText" in e && "id" in e && "children" in e && Array.isArray(e.children), ac = (e, t) => {
	let n = [], r = "", i = 0;
	for (; i < e.length;) if (e.slice(i, i + 2) === "{{" && e.slice(i + 2).includes("}}")) {
		r &&= (n.push({ text: r }), "");
		let a = e.indexOf("}}", i), o = e.slice(i + 2, a), s = t.find(({ id: e }) => e === o);
		if (s) {
			let { id: e, token: t } = s;
			n.push({
				type: "token",
				id: e,
				tokenText: t.text,
				className: t.className,
				tooltip: t.tooltip,
				showTokenEditIcon: t.showTokenEditIcon,
				children: [{ text: "" }]
			});
		} else r += e.slice(i, a + 2);
		i = a + 2;
	} else r += e[i], i++;
	return n.push({ text: r }), n.length === 0 && n.push({ text: "" }), n;
}, oc = (e, t, { markdown: n = !1 } = {}) => e ? n ? kc(e, t) : e.split("\n").map((e) => ({
	type: "paragraph",
	children: ac(e, t)
})) : [{
	type: "paragraph",
	children: [{ text: "" }]
}], sc = (e, { markdown: t = !1 } = {}) => t ? bc(e) : e.map((e, t) => O.isElement(e) ? ic(e) ? `{{${e.id}}}` : (t > 0 ? "\n" : "") + sc(e.children) : e.text).join(""), cc = "<br/>", lc = /^<br\s*\/?>/i, uc = (e) => e.replace(/([\\*_`])/g, "\\$1").replace(/<(br\s*\/?)>/gi, "\\<$1>"), dc = (e) => e.replace(/^(\s*)([-+#>])/, "$1\\$2").replace(/^(\s*)(\d+)([.)])/, "$1$2\\$3"), fc = (e, t) => {
	let n = e.match(/^(\s*)([\s\S]*?)(\s*)$/);
	if (!n) return e;
	let [, r, i, a] = n;
	return i ? `${r}${t}${i}${t}${a}` : e;
}, pc = (e) => {
	let t = uc(e.text).replace(/\n/g, cc);
	return t && (e.bold && (t = fc(t, "**")), e.italic && (t = fc(t, "*")), t);
}, mc = (e) => e.map((e) => O.isElement(e) ? ic(e) ? `{{${e.id}}}` : mc(e.children) : pc(e)).join(""), hc = "  ", gc = (e) => O.isElement(e) && (e.type === "bulleted-list" || e.type === "numbered-list"), _c = (e) => {
	let t = [], n = [];
	return e.children.forEach((e) => {
		gc(e) ? n.push(e) : O.isElement(e) && e.type === "list-item-content" ? t.push(...e.children) : t.push(e);
	}), {
		content: t,
		sublists: n
	};
}, vc = (e, t) => {
	let n = hc.repeat(t), r = [];
	return e.children.forEach((i, a) => {
		if (!O.isElement(i)) return;
		let { content: o, sublists: s } = _c(i), c = e.type === "numbered-list" ? `${a + 1}. ` : "- ";
		r.push(n + c + mc(o)), s.forEach((e) => r.push(...vc(e, t + 1)));
	}), r;
}, yc = (e) => {
	let t = [];
	return e.forEach((e) => {
		gc(e) ? t.push(...vc(e, 0)) : O.isElement(e) && e.type === "heading" ? t.push(`${"#".repeat(e.level)} ${mc(e.children)}`) : O.isElement(e) ? t.push(dc(mc(e.children))) : t.push(pc(e));
	}), t;
}, bc = (e) => yc(e).join("\n"), xc = (e) => O.isElement(e) && e.type === "token", Sc = (e) => {
	let t = [];
	e.forEach((e) => {
		if (xc(e)) {
			let e = t[t.length - 1];
			(!e || xc(e)) && t.push({ text: "" });
		}
		t.push(e);
	});
	let n = t[t.length - 1];
	return (!n || xc(n)) && t.push({ text: "" }), t;
}, Cc = (e) => {
	let t = [], n = "", r = !1, i = !1, a = 0, o = () => {
		if (!n) return;
		let e = { text: n };
		r && (e.bold = !0), i && (e.italic = !0), t.push(e), n = "";
	};
	for (; a < e.length;) if (e[a] === "\\" && a + 1 < e.length) n += e[a + 1], a += 2;
	else {
		if (e[a] === "<") {
			let t = lc.exec(e.slice(a));
			if (t) {
				n += "\n", a += t[0].length;
				continue;
			}
		}
		e.startsWith("***", a) ? (o(), r = !r, i = !i, a += 3) : e.startsWith("**", a) ? (o(), r = !r, a += 2) : e[a] === "*" ? (o(), i = !i, a += 1) : (n += e[a], a += 1);
	}
	return o(), t;
}, wc = (e, t) => {
	let n = [], r = "", i = 0, a = () => {
		r &&= (n.push(...Cc(r)), "");
	};
	for (; i < e.length;) if (e.slice(i, i + 2) === "{{" && e.slice(i + 2).includes("}}")) {
		let o = e.indexOf("}}", i), s = e.slice(i + 2, o), c = t.find(({ id: e }) => e === s);
		if (c) {
			a();
			let { id: e, token: t } = c;
			n.push({
				type: "token",
				id: e,
				tokenText: t.text,
				className: t.className,
				tooltip: t.tooltip,
				showTokenEditIcon: t.showTokenEditIcon,
				children: [{ text: "" }]
			});
		} else r += e.slice(i, o + 2);
		i = o + 2;
	} else r += e[i], i++;
	return a(), Sc(n);
}, Tc = /^(\s*)([-*+])\s+(.*)$/, Ec = /^(\s*)(\d+)[.)]\s+(.*)$/, Dc = /^(#{1,6})\s+(.*)$/, Oc = (e, t) => ({
	type: "list-item",
	children: [{
		type: "list-item-content",
		children: wc(e, t)
	}]
}), kc = (e, t) => {
	let n = e.split("\n"), r = [], i = [];
	return n.forEach((e) => {
		let n = e.match(Dc);
		if (n) {
			i = [], r.push({
				type: "heading",
				level: Math.min(n[1].length, 3),
				children: wc(n[2], t)
			});
			return;
		}
		let a = e.match(Tc), o = a ? null : e.match(Ec);
		if (!a && !o) {
			i = [], r.push({
				type: "paragraph",
				children: wc(e, t)
			});
			return;
		}
		let s = a || o, c = Math.floor(s[1].length / 2), l = a ? "bulleted-list" : "numbered-list", u = Oc(s[3], t);
		for (; i.length && i[i.length - 1].level > c;) i.pop();
		let d = i[i.length - 1];
		if (d && d.level === c && d.type !== l && (i.pop(), d = i[i.length - 1]), d && d.level === c) {
			d.list.children.push(u);
			return;
		}
		let f = {
			type: l,
			children: [u]
		};
		if (!d) r.push(f);
		else {
			let e = d.list.children, t = e[e.length - 1];
			t ? t.children.push(f) : r.push(f);
		}
		i.push({
			level: c,
			type: l,
			list: f
		});
	}), r;
}, $ = {
	bold: [[["$metaOrCtrl"], "KeyB"]],
	italic: [[["$metaOrCtrl"], "KeyI"]],
	numberedList: [[["Control", "$controlOrAlt"], "Digit7"]],
	bulletedList: [[["Control", "$controlOrAlt"], "Digit8"]],
	heading1: [[["Control", "$controlOrAlt"], "Digit1"]],
	heading2: [[["Control", "$controlOrAlt"], "Digit2"]],
	heading3: [[["Control", "$controlOrAlt"], "Digit3"]]
}, Ac = [
	{
		keys: $.bold,
		capability: "bold",
		run: (e) => ec(e, "bold")
	},
	{
		keys: $.italic,
		capability: "italic",
		run: (e) => ec(e, "italic")
	},
	{
		keys: $.numberedList,
		capability: "lists",
		block: !0,
		run: (e) => Xs(e, "numbered-list")
	},
	{
		keys: $.bulletedList,
		capability: "lists",
		block: !0,
		run: (e) => Xs(e, "bulleted-list")
	},
	{
		keys: $.heading1,
		capability: "headings",
		block: !0,
		run: (e) => Hs(e, 1)
	},
	{
		keys: $.heading2,
		capability: "headings",
		block: !0,
		run: (e) => Hs(e, 2)
	},
	{
		keys: $.heading3,
		capability: "headings",
		block: !0,
		run: (e) => Hs(e, 3)
	}
], jc = (e) => {
	let { normalizeNode: t, insertBreak: n, insertSoftBreak: r, deleteBackward: i } = e;
	return e.insertBreak = () => {
		let t = Ys(e), { selection: r } = e;
		if (t && r && M.isCollapsed(r)) {
			let [, n] = t;
			if (D.string(e, [...n, 0]) === "") {
				Qs(e) || Xs(e, Js(e, "numbered-list") ? "numbered-list" : "bulleted-list");
				return;
			}
			let i = D.before(e, r.anchor, { unit: "character" });
			i && D.string(e, {
				anchor: i,
				focus: r.anchor
			}) === "\n" && N.delete(e, { at: {
				anchor: i,
				focus: r.anchor
			} }), N.splitNodes(e, {
				match: Ks,
				always: !0
			});
		} else n();
	}, e.insertSoftBreak = () => {
		Ys(e) ? D.insertText(e, "\n") : r();
	}, e.deleteBackward = (t) => {
		let { selection: n } = e;
		if (n && M.isCollapsed(n)) {
			let r = Ys(e);
			if (r) {
				let [, a] = r;
				if (j.equals(n.anchor, D.start(e, a))) {
					if (a[a.length - 1] > 0) {
						N.mergeNodes(e, { at: a });
						return;
					}
					let n = A.parent(A.parent(a));
					if (!Ks(k.get(e, n))) {
						Xs(e, Js(e, "numbered-list") ? "numbered-list" : "bulleted-list"), i(t);
						return;
					}
				}
			}
		}
		i(t);
	}, e.normalizeNode = (n) => {
		let [r, i] = n;
		if (O.isElement(r) && Ws(r.type)) {
			if (r.children.length === 0) {
				N.removeNodes(e, { at: i });
				return;
			}
			if (i[i.length - 1] > 0) {
				let t = A.previous(i), n = k.get(e, t);
				if (O.isElement(n) && n.type === r.type) {
					N.mergeNodes(e, { at: i });
					return;
				}
			}
			for (let [t, n] of k.children(e, i)) if (!Ks(t)) {
				N.wrapNodes(e, {
					type: "list-item",
					children: []
				}, { at: n });
				return;
			}
		}
		if (Ks(r)) {
			let [t] = D.parent(e, i);
			if (!Gs(t)) {
				N.unwrapNodes(e, { at: i });
				return;
			}
			let n = r.children, a = n[0];
			if (!(O.isElement(a) && a.type === "list-item-content")) {
				N.insertNodes(e, {
					type: "list-item-content",
					children: [{ text: "" }]
				}, { at: [...i, 0] });
				return;
			}
			for (let t = 1; t < n.length; t++) {
				let r = n[t], a = n[t - 1];
				if (O.isElement(r) && r.type === "list-item-content" && O.isElement(a) && a.type === "list-item-content") {
					N.mergeNodes(e, { at: [...i, t] });
					return;
				}
			}
		}
		if (O.isElement(r) && r.type === "list-item-content") {
			let [t] = D.parent(e, i);
			if (!Ks(t)) {
				N.setNodes(e, { type: "paragraph" }, { at: i });
				return;
			}
		}
		t(n);
	}, e;
}, Mc = t.emojis.flat(), Nc = 30, Pc = (e, t, n, r) => {
	if (r) {
		let r = D.end(e, t), i = D.start(e, t);
		return j.isBefore(n, i) ? D.after(e, t) ?? null : j.isAfter(n, r) ? D.before(e, t) ?? null : D.after(e, t) ?? null;
	}
	return j.compare(n, D.start(e, t)) < 0 ? D.after(e, t) ?? null : null;
}, Fc = (e, t, n, r, i, a) => {
	let [o] = D.node(e, t);
	if (O.isElement(o) && e.isVoid(o)) {
		if (n && M.isCollapsed(n)) {
			let [o] = M.edges(n), s = Pc(e, t, o, a);
			if (s && r(s)) return N.select(e, s), i.current = e.selection, !0;
		} else {
			let n = a ? D.after(e, t) : null;
			if (n && r(n)) return N.select(e, n), i.current = e.selection, !0;
		}
	}
	return !1;
}, Ic = (t) => {
	let { value: n, onChange: l, onBlur: d, placeholder: h, variables: S, mode: w = "input", trigger: T = "{", insertVariableText: E = "+ Insert variable", richText: k, toolbarPosition: A = "top", id: j, editorWrapperClassName: ee, fieldWrapperProps: oe, popoverTopButtons: ce, onTokenClick: le, allowTokenReplacement: ue, createVariable: de, itemActions: P, disabled: fe } = t, F = k === !0 ? {
		bold: !0,
		italic: !0,
		lists: !0,
		headings: !0,
		emoji: !0
	} : k || void 0, I = !!(F?.bold || F?.italic || F?.lists || F?.headings), pe = !!F?.emoji, [L, me] = v(null), [he, ge] = v(0), [_e, ve] = v(""), [R, ye] = v(""), [be, xe] = v(!1), [Se, z] = v(null), [Ce, we] = v(null), [Te, Ee] = v(null), [De, Oe] = v(""), [ke, Ae] = v(0), [je, Me] = v(null), Ne = _(null), Pe = _(null), B = _(null), Fe = _({ getBoundingClientRect: () => new DOMRect() });
	Bs(() => ye(_e), 300, [_e]);
	let Ie = _(S);
	Ie.current = S;
	let V = g(() => jc(nc(se(ne(te())), () => Ie.current)), []), Le = g(() => oc(n, S, { markdown: I }), [
		n,
		S,
		I
	]), Re = g(() => {
		if (!pe) return [];
		let e = De.toLowerCase();
		return e ? Mc.filter((t) => t.shortNames?.some((t) => t.includes(e))).slice(0, Nc) : [];
	}, [pe, De]), ze = g(() => Rs(S.filter((e) => e.menu !== void 0), ["menu.category", "token.text"]), [S]), H = g(() => {
		let e = R ? de?.(R) : void 0, t = e && !S.some(({ id: t }) => t === e.id) ? [e] : [];
		return !ze || ze.length === 0 ? t : R ? [...new Is(ze, {
			keys: ["token.text"],
			threshold: .2,
			distance: 200,
			shouldSort: !1
		}).search(R).map(({ item: e }) => e), ...t] : ze;
	}, [
		ze,
		R,
		de,
		S
	]), Be = g(() => Ls(H, (e) => e.menu?.category || "Uncategorized"), [H]), U = g(() => Ls(S.filter((e) => e.menu !== void 0), (e) => e.menu?.category || "Uncategorized"), [S]), Ve = p((e) => {
		if (!e) return !1;
		try {
			return D.hasPath(V, e.path) && e.offset <= D.string(V, e.path).length;
		} catch {
			return !1;
		}
	}, [V]), He = p((e) => {
		if (Te) N.delete(V, { at: Te });
		else {
			let { selection: e } = V;
			e || N.select(V, D.end(V, []));
		}
		N.insertText(V, e.emoji), Ee(null), l(sc(V.children, { markdown: I }));
	}, [
		V,
		Te,
		I,
		l
	]), Ue = p((e) => {
		for (let { keys: t, capability: n, block: r, run: i } of Ac) if (!(r && w === "input") && F?.[n] && u(t, e)) {
			e.preventDefault(), i(V);
			return;
		}
		if (Te && Re.length > 0) switch (e.key) {
			case "ArrowDown":
				e.preventDefault(), Ae((e) => e >= Re.length - 1 ? 0 : e + 1);
				break;
			case "ArrowUp":
				e.preventDefault(), Ae((e) => e <= 0 ? Re.length - 1 : e - 1);
				break;
			case "Tab":
			case "Enter":
				e.preventDefault(), He(Re[ke]);
				break;
			case "Escape": e.preventDefault(), Ee(null);
		}
		else if (L && H.length > 0) {
			let t = (e, t) => {
				let n = H.length, r = e;
				for (let e = 0; e < n; e++) if (r = t === 1 ? r >= n - 1 ? 0 : r + 1 : r <= 0 ? n - 1 : r - 1, !H[r].menu?.disabled) return r;
				return e;
			};
			switch (e.key) {
				case "ArrowDown":
					e.preventDefault(), ge(t(he, 1));
					break;
				case "ArrowUp":
					e.preventDefault(), ge(t(he, -1));
					break;
				case "Tab":
				case "Enter": {
					e.preventDefault();
					let t = H[he];
					if (t.menu?.disabled) break;
					N.delete(V, { at: L }), rc(V, t.id, t.token.text, t.token.className, t.token.tooltip, t.token.showTokenEditIcon), me(null), l(sc(V.children, { markdown: I }));
					break;
				}
				case "Escape": e.preventDefault(), me(null);
			}
		} else F?.lists && e.key === "Tab" && Ys(V) ? (e.preventDefault(), (e.shiftKey ? Qs(V) : Zs(V)) && l(sc(V.children, { markdown: I }))) : w === "input" && e.key === "Enter" && e.preventDefault();
	}, [
		V,
		H,
		he,
		L,
		w,
		I,
		F,
		Te,
		Re,
		ke,
		He,
		l
	]);
	m(() => {
		if (L && H.length > 0) try {
			let e = ie.toDOMRange(V, L).getBoundingClientRect(), t = window.innerHeight - e.bottom < 300 ? `${e.top + window.scrollY - 300}px` : `${e.bottom + window.scrollY}px`, n = `${e.left + window.scrollX}px`;
			z({
				top: t,
				left: n
			});
		} catch (e) {
			console.error("SlateEditor: Unable to set position", e), z(null);
		}
		else z(null);
	}, [
		V,
		L,
		H
	]), m(() => {
		if (Ne.current) {
			let e = Ne.current.querySelector("[aria-selected=\"true\"]");
			e && e.scrollIntoView({
				block: "nearest",
				inline: "nearest"
			});
		}
	}, [he]), m(() => {
		if (Te && Re.length > 0) try {
			let e = ie.toDOMRange(V, Te).getBoundingClientRect(), t = window.innerHeight - e.bottom < 300 ? `${e.top + window.scrollY - 300}px` : `${e.bottom + window.scrollY}px`, n = `${e.left + window.scrollX}px`;
			Me({
				top: t,
				left: n
			});
		} catch (e) {
			console.error("SlateEditor: Unable to set emoji position", e), Me(null);
		}
		else Me(null);
	}, [
		V,
		Te,
		Re
	]), m(() => {
		if (Pe.current) {
			let e = Pe.current.querySelector("[aria-selected=\"true\"]");
			e && e.scrollIntoView({
				block: "nearest",
				inline: "nearest"
			});
		}
	}, [ke]);
	let We = p((e) => {
		if (e.menu?.disabled) return;
		if (Ce !== null) {
			N.setNodes(V, {
				id: e.id,
				tokenText: e.token.text,
				className: e.token.className,
				tooltip: e.token.tooltip,
				showTokenEditIcon: e.token.showTokenEditIcon
			}, {
				at: [],
				match: (e) => O.isElement(e) && e.type === "token" && e.id === Ce,
				voids: !0
			}), we(null), xe(!1), l(sc(V.children, { markdown: I }));
			return;
		}
		let { selection: t } = V;
		if (L && N.delete(V, { at: L }), t) rc(V, e.id, e.token.text, e.token.className, e.token.tooltip, e.token.showTokenEditIcon);
		else {
			let t = D.end(V, []);
			N.select(V, t), rc(V, e.id, e.token.text, e.token.className, e.token.tooltip, e.token.showTokenEditIcon);
		}
		xe(!1), me(null), l(sc(V.children, { markdown: I }));
	}, [
		V,
		l,
		L,
		Ce,
		I
	]), Ge = p((e, t) => {
		Fe.current = { getBoundingClientRect: () => t }, we(e), setTimeout(() => xe(!0), 0);
	}, []), Ke = p((e) => /* @__PURE__ */ b(Vc, {
		...e,
		mode: w,
		onTokenClick: le,
		onReplaceTokenClick: Ge,
		allowTokenReplacement: ue,
		variables: S
	}), [
		w,
		le,
		ue,
		Ge,
		S
	]), qe = p((e) => /* @__PURE__ */ b(Bc, { ...e }), []);
	return /* @__PURE__ */ b("div", {
		className: C(Q.root, { [Q.disabled]: fe }),
		children: /* @__PURE__ */ x(vo, {
			open: be,
			onOpenChange: (e) => {
				xe(e), e || we(null);
			},
			children: [
				/* @__PURE__ */ b(r, {
					...oe,
					disabled: fe,
					children: /* @__PURE__ */ x(ae, {
						editor: V,
						value: Le,
						onChange: (e) => {
							l(sc(e, { markdown: I }));
							try {
								let { selection: e } = V;
								if (e && M.isCollapsed(e)) {
									let [t] = M.edges(e);
									if (t.path.length > 1) {
										let e = t.path.slice(0, -1);
										if (D.hasPath(V, e) && Fc(V, e, B.current, Ve, B, !0)) return;
									}
								}
								let t = B.current;
								if (e && M.isCollapsed(e)) {
									let [n] = M.edges(e);
									if (!Ve(n)) {
										N.select(V, D.end(V, [0])), me(null), Ee(null), B.current = V.selection;
										return;
									}
									if (Fc(V, n.path, t, Ve, B, !1)) return;
									let r = {
										path: n.path,
										offset: 0
									}, i = D.string(V, D.range(V, r, n)), a = i.lastIndexOf("\n") + 1, o = i.slice(a), s = o.lastIndexOf(T);
									if (s !== -1) {
										let t = D.range(V, {
											path: n.path,
											offset: a + s
										}, n), r = D.string(V, t).match(RegExp(`^${T}([\\w-]+(?:\\s+[\\w-]+)*\\s*)$`)), i = D.after(V, n), o = D.range(V, n, i), c = D.string(V, o).match(/^(\s|$)/);
										if (r && c) {
											me(t), Ee(null), ve(r[1]), ge(0), B.current = e;
											return;
										}
									}
									if (pe) {
										let t = o.lastIndexOf(":");
										if (t !== -1) {
											let r = t > 0 ? o[t - 1] : "", i = t === 0 || /\s/.test(r), s = o.slice(t + 1);
											if (i && /^[\w+-]*$/.test(s)) {
												let r = D.range(V, {
													path: n.path,
													offset: a + t
												}, n);
												Ee(r), Oe(s), Ae(0), me(null), B.current = e;
												return;
											}
										}
									}
								}
								me(null), Ee(null), B.current = e;
							} catch (e) {
								console.error("SlateEditor: Error in onChange:", e);
							}
						},
						children: [
							F && A === "top" && /* @__PURE__ */ b(Uc, {
								richText: F,
								onInsertEmoji: He,
								insertVariableText: E,
								showInsertVariable: S.length > 0,
								position: A,
								disabled: fe
							}),
							/* @__PURE__ */ b("div", {
								className: C(Q.editorWrapper, ee, {
									[Q.textarea]: w === "textarea",
									[Q.input]: w === "input",
									[Q.disabled]: fe
								}),
								children: /* @__PURE__ */ b(re, {
									id: j,
									renderElement: Ke,
									renderLeaf: qe,
									placeholder: h,
									className: Q.editor,
									onKeyDown: Ue,
									onBlur: d,
									readOnly: fe
								})
							}),
							F && A === "bottom" && /* @__PURE__ */ b(Uc, {
								richText: F,
								onInsertEmoji: He,
								insertVariableText: E,
								showInsertVariable: S.length > 0,
								position: A,
								disabled: fe
							}),
							L && H.length > 0 && Se && /* @__PURE__ */ b(a, {
								containerId: "portal-root",
								children: /* @__PURE__ */ b("div", {
									ref: Ne,
									className: Q.portal,
									style: {
										top: Se.top,
										left: Se.left
									},
									children: Object.keys(Be).map((t) => /* @__PURE__ */ x(f, { children: [t !== "Uncategorized" && /* @__PURE__ */ b(e, {
										className: Q.divider,
										children: /* @__PURE__ */ b(y, { children: t })
									}), Be[t].map((e) => {
										let t = H.findIndex((t) => t.id === e.id), n = e.menu?.disabled, r = /* @__PURE__ */ b("div", {
											className: C(Q.suggestion, {
												[Q.highlighted]: t === he,
												[Q.disabled]: n
											}),
											"aria-selected": t === he,
											"aria-disabled": n,
											onClick: () => We(e),
											children: /* @__PURE__ */ b(o.Paragraph, {
												variant: "2",
												children: /* @__PURE__ */ b(s, {
													text: e.token.text,
													highlight: R
												})
											})
										}, `${e.token.text}-${t}`);
										return n && e.menu?.disabledReason ? /* @__PURE__ */ b(c, {
											content: e.menu.disabledReason,
											side: "right",
											delayDuration: 0,
											children: r
										}, `${e.token.text}-${t}`) : r;
									})] }, t))
								})
							}),
							Te && Re.length > 0 && je && /* @__PURE__ */ b(a, {
								containerId: "portal-root",
								children: /* @__PURE__ */ b("div", {
									ref: Pe,
									className: Q.portal,
									style: {
										top: je.top,
										left: je.left
									},
									children: Re.map((e, t) => /* @__PURE__ */ x("div", {
										className: C(Q.suggestion, Q.emojiRow, { [Q.highlighted]: t === ke }),
										"aria-selected": t === ke,
										onMouseDown: (t) => {
											t.preventDefault(), He(e);
										},
										children: [/* @__PURE__ */ b("span", {
											className: Q.emojiGlyph,
											children: e.emoji
										}), /* @__PURE__ */ x(o.Paragraph, {
											variant: "2",
											children: [
												":",
												e.shortName,
												":"
											]
										})]
									}, `${e.shortName}-${t}`))
								})
							})
						]
					})
				}),
				Ce && /* @__PURE__ */ b(yo, { virtualRef: Fe }),
				!F && S.length > 0 && /* @__PURE__ */ b(bo, {
					asChild: !0,
					children: /* @__PURE__ */ b("button", {
						className: Q.addButton,
						type: "button",
						disabled: fe,
						children: E
					})
				}),
				/* @__PURE__ */ b(xo, { children: /* @__PURE__ */ x(So, {
					side: "bottom",
					align: "end",
					sideOffset: 5,
					className: Q.buttonPortal,
					onOpenAutoFocus: (e) => e.preventDefault(),
					children: [ce?.map(({ label: e, onClick: t }) => /* @__PURE__ */ b("div", {
						className: Q.popoverTopButton,
						onClick: () => {
							xe(!1), t(Ce);
						},
						children: e
					}, e)), Object.keys(U).map((t) => /* @__PURE__ */ x(f, { children: [t !== "Uncategorized" && /* @__PURE__ */ b(e, {
						className: Q.divider,
						children: /* @__PURE__ */ b(y, { children: t })
					}), U[t].map((e, t) => {
						let n = e.menu?.disabled, r = /* @__PURE__ */ x("div", {
							className: C(Q.suggestion, {
								[Q.disabled]: n,
								[Q.suggestionWithActions]: !!P
							}),
							"aria-disabled": n,
							onClick: () => We(e),
							children: [/* @__PURE__ */ b(o.Paragraph, {
								variant: "2",
								children: e.token.text
							}), P && !n && /* @__PURE__ */ b("div", {
								className: Q.suggestionActions,
								onClick: (e) => e.stopPropagation(),
								children: P.map((t) => /* @__PURE__ */ b("button", {
									type: "button",
									className: Q.suggestionActionButton,
									onClick: () => {
										xe(!1), t.onClick(e.id);
									},
									"aria-label": t.label,
									children: /* @__PURE__ */ b(i, {
										name: t.icon,
										size: 16
									})
								}, t.label))
							})]
						}, `${e.id}-${t}`);
						return n && e.menu?.disabledReason ? /* @__PURE__ */ b(c, {
							content: e.menu.disabledReason,
							side: "right",
							delayDuration: 0,
							children: r
						}, `${e.id}-${t}`) : r;
					})] }, t))]
				}) })
			]
		})
	});
}, Lc = (e) => {
	let { value: t, onChange: n, onBlur: r, placeholder: i, variables: a, mode: o, trigger: s, insertVariableText: c, richText: l, toolbarPosition: u, id: d, popoverTopButtons: f, onTokenClick: p, allowTokenReplacement: m, createVariable: h, itemActions: g, disabled: _, ...v } = e;
	return /* @__PURE__ */ b(Ic, {
		value: t,
		onChange: n,
		onBlur: r,
		placeholder: i,
		variables: a,
		mode: o,
		trigger: s,
		insertVariableText: c,
		richText: l,
		toolbarPosition: u,
		id: d,
		popoverTopButtons: f,
		onTokenClick: p,
		allowTokenReplacement: m,
		createVariable: h,
		itemActions: g,
		disabled: _,
		fieldWrapperProps: v
	});
}, Rc = (e) => {
	let { controller: t, fieldWrapperProps: n } = w(e), { onChange: r, onBlur: i, value: a } = t.field;
	return /* @__PURE__ */ b(Ic, {
		value: a,
		onChange: r,
		onBlur: i,
		fieldWrapperProps: n,
		...e.componentProps,
		disabled: n.disabled
	});
}, zc = (e) => {
	let { input: t, ...n } = e;
	return /* @__PURE__ */ b(Lc, {
		value: t.value,
		onChange: t.onChange,
		onBlur: () => t.onBlur(void 0),
		...n
	});
}, Bc = ({ attributes: e, children: t, leaf: n }) => (n.bold && (t = /* @__PURE__ */ b("strong", { children: t })), n.italic && (t = /* @__PURE__ */ b("em", { children: t })), n.underline && (t = /* @__PURE__ */ b("u", { children: t })), /* @__PURE__ */ b("span", {
	...e,
	children: t
})), Vc = ({ attributes: e, children: t, element: n, mode: r, onTokenClick: i, onReplaceTokenClick: a, allowTokenReplacement: o, variables: s }) => {
	if (n.type === "token") {
		let r = s?.find((e) => e.id === n.id), c = r == null, l = r != null && !r.menu, u = (s?.length ?? 0) > 0;
		return /* @__PURE__ */ b(Wc, {
			attributes: e,
			element: n,
			unresolved: c,
			onTokenClick: c ? void 0 : i,
			onReplaceTokenClick: u && (c || l && o) ? a : void 0,
			children: t
		});
	}
	if (n.type === "heading") {
		let r = `h${n.level}`;
		return /* @__PURE__ */ b(r, {
			className: Q.heading,
			...e,
			children: t
		});
	}
	return n.type === "bulleted-list" ? /* @__PURE__ */ b("ul", {
		className: Q.list,
		...e,
		children: t
	}) : n.type === "numbered-list" ? /* @__PURE__ */ b("ol", {
		className: Q.list,
		...e,
		children: t
	}) : n.type === "list-item" ? /* @__PURE__ */ b("li", {
		...e,
		children: t
	}) : n.type === "list-item-content" ? /* @__PURE__ */ b("div", {
		className: Q.listItemContent,
		...e,
		children: t
	}) : b(r === "input" ? "span" : "p", {
		...e,
		children: t
	});
}, Hc = ({ icon: e, label: t, shortcut: n, isActive: r, onToggle: a }) => {
	let o = n ? l(n) : "";
	return /* @__PURE__ */ b(c, {
		content: o ? `${t} (${o})` : t,
		side: "top",
		delayDuration: 300,
		children: /* @__PURE__ */ b("button", {
			type: "button",
			className: C(Q.toolbarButton, { [Q.toolbarButtonActive]: r }),
			"aria-pressed": r,
			"aria-label": t,
			onMouseDown: (e) => {
				e.preventDefault(), a();
			},
			children: /* @__PURE__ */ b(i, {
				name: e,
				size: 16
			})
		})
	});
}, Uc = ({ richText: e, onInsertEmoji: t, insertVariableText: r, showInsertVariable: a, position: o, disabled: s }) => {
	let c = oe(), [l, u] = v(!1);
	return /* @__PURE__ */ x("div", {
		className: C(Q.toolbar, o === "bottom" ? Q.toolbarBottom : Q.toolbarTop),
		children: [
			e.headings && /* @__PURE__ */ x(y, { children: [
				/* @__PURE__ */ b(Hc, {
					icon: "heading-1",
					label: "Heading 1",
					shortcut: $.heading1,
					isActive: Vs(c, 1),
					onToggle: () => Hs(c, 1)
				}),
				/* @__PURE__ */ b(Hc, {
					icon: "heading-2",
					label: "Heading 2",
					shortcut: $.heading2,
					isActive: Vs(c, 2),
					onToggle: () => Hs(c, 2)
				}),
				/* @__PURE__ */ b(Hc, {
					icon: "heading-3",
					label: "Heading 3",
					shortcut: $.heading3,
					isActive: Vs(c, 3),
					onToggle: () => Hs(c, 3)
				})
			] }),
			e.bold && /* @__PURE__ */ b(Hc, {
				icon: "bold",
				label: "Bold",
				shortcut: $.bold,
				isActive: $s(c, "bold"),
				onToggle: () => ec(c, "bold")
			}),
			e.italic && /* @__PURE__ */ b(Hc, {
				icon: "italic",
				label: "Italic",
				shortcut: $.italic,
				isActive: $s(c, "italic"),
				onToggle: () => ec(c, "italic")
			}),
			e.lists && /* @__PURE__ */ x(y, { children: [/* @__PURE__ */ b(Hc, {
				icon: "list-ol",
				label: "Numbered list",
				shortcut: $.numberedList,
				isActive: Js(c, "numbered-list"),
				onToggle: () => Xs(c, "numbered-list")
			}), /* @__PURE__ */ b(Hc, {
				icon: "list-ul",
				label: "Bulleted list",
				shortcut: $.bulletedList,
				isActive: Js(c, "bulleted-list"),
				onToggle: () => Xs(c, "bulleted-list")
			})] }),
			e.emoji && /* @__PURE__ */ x(vo, {
				open: l,
				onOpenChange: u,
				children: [/* @__PURE__ */ b(bo, {
					asChild: !0,
					children: /* @__PURE__ */ b("button", {
						type: "button",
						className: Q.toolbarButton,
						disabled: s,
						"aria-label": "Emoji",
						children: /* @__PURE__ */ b(i, {
							name: "smile",
							size: 16
						})
					})
				}), /* @__PURE__ */ b(xo, { children: /* @__PURE__ */ b(So, {
					side: "bottom",
					align: "start",
					sideOffset: 5,
					className: Q.emojiPickerPortal,
					children: /* @__PURE__ */ b(n, { onSelect: (e) => {
						t({
							emoji: e,
							shortName: "",
							shortNames: []
						}), u(!1);
					} })
				}) })]
			}),
			a && /* @__PURE__ */ b(bo, {
				asChild: !0,
				children: /* @__PURE__ */ b("button", {
					type: "button",
					className: C(Q.toolbarButton, Q.toolbarInsertVariable),
					disabled: s,
					children: r
				})
			})
		]
	});
}, Wc = ({ attributes: e, element: t, children: n, unresolved: r, onTokenClick: a, onReplaceTokenClick: o }) => {
	let s = !!a || !!o, l = s && t.showTokenEditIcon !== !1, u = r ? C(Q.token, Q.unresolvedToken) : t.className || Q.token, d = p((e) => {
		o ? o(t.id, e.currentTarget.getBoundingClientRect()) : a && a(t.id);
	}, [
		o,
		a,
		t.id
	]), f = /* @__PURE__ */ x("span", {
		...e,
		contentEditable: !1,
		onClick: d,
		style: {
			userSelect: "none",
			pointerEvents: t.tooltip || s ? "auto" : "none",
			cursor: s ? "pointer" : void 0
		},
		className: u,
		children: [
			/* @__PURE__ */ b("span", {
				contentEditable: !1,
				children: t.tokenText
			}),
			l && /* @__PURE__ */ b(i, {
				name: "pen",
				size: 12,
				className: Q.tokenEditIcon
			}),
			n
		]
	});
	return t.tooltip ? /* @__PURE__ */ b(c, {
		content: t.tooltip,
		side: "top",
		delayDuration: 0,
		children: f
	}) : f;
};
export { Rc as HookTokenInputSlate, zc as ReduxFormTokenInputSlate, Lc as TokenInputSlate, Ic as TokenInputSlateCore };

//# sourceMappingURL=index.js.map